var bodyScrollLockOptions = {
  reserveScrollBarGap: true,
};

// Define a global function to load a script
window.loadScript = function(url) {
  // Check if the script already exists
  var existingScript = document.querySelector(`script[src="${url}"]`);

  if (existingScript) {
    return;
  }

  // Create a new script element
  var script = document.createElement('script');
  script.src = url;
  document.body.appendChild(script);
};



var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/**
 * DOM event delegator
 *
 * The delegator will listen
 * for events that bubble up
 * to the root node.
 *
 * @constructor
 * @param {Node|string} [root] The root node or a selector string matching the root node
 */
function Delegate(root) {
  /**
   * Maintain a map of listener
   * lists, keyed by event name.
   *
   * @type Object
   */
  this.listenerMap = [{}, {}];
  if (root) {
    this.root(root);
  }

  /** @type function() */
  this.handle = Delegate.prototype.handle.bind(this);

  // Cache of event listeners removed during an event cycle
  this._removedListeners = [];
}

/**
 * Start listening for events
 * on the provided DOM element
 *
 * @param  {Node|string} [root] The root node or a selector string matching the root node
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.root = function (root) {
  const listenerMap = this.listenerMap;
  let eventType;

  // Remove master event listeners
  if (this.rootElement) {
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, false);
      }
    }
  }

  // If no root or root is not
  // a dom node, then remove internal
  // root reference and exit here
  if (!root || !root.addEventListener) {
    if (this.rootElement) {
      delete this.rootElement;
    }
    return this;
  }

  /**
   * The root node at which
   * listeners are attached.
   *
   * @type Node
   */
  this.rootElement = root;

  // Set up master event listeners
  for (eventType in listenerMap[1]) {
    if (listenerMap[1].hasOwnProperty(eventType)) {
      this.rootElement.addEventListener(eventType, this.handle, true);
    }
  }
  for (eventType in listenerMap[0]) {
    if (listenerMap[0].hasOwnProperty(eventType)) {
      this.rootElement.addEventListener(eventType, this.handle, false);
    }
  }

  return this;
};

/**
 * @param {string} eventType
 * @returns boolean
 */
Delegate.prototype.captureForType = function (eventType) {
  return (
    ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
      eventType
    ) !== -1
  );
};

/**
 * Attach a handler to one
 * event for all elements
 * that match the selector,
 * now or in the future
 *
 * The handler function receives
 * three arguments: the DOM event
 * object, the node that matched
 * the selector while the event
 * was bubbling and a reference
 * to itself. Within the handler,
 * 'this' is equal to the second
 * argument.
 *
 * The node that actually received
 * the event can be accessed via
 * 'event.target'.
 *
 * @param {string} eventType Listen for these events
 * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
 * @param {function()} handler Handler function - event data passed here will be in event.data
 * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
  let root;
  let listenerMap;
  let matcher;
  let matcherParam;

  if (!eventType) {
    throw new TypeError("Invalid event type: " + eventType);
  }

  // handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // Fallback to sensible defaults
  // if useCapture not set
  if (useCapture === undefined) {
    useCapture = this.captureForType(eventType);
  }

  if (typeof handler !== "function") {
    throw new TypeError("Handler must be a type of Function");
  }

  root = this.rootElement;
  listenerMap = this.listenerMap[useCapture ? 1 : 0];

  // Add master handler for type if not created yet
  if (!listenerMap[eventType]) {
    if (root) {
      root.addEventListener(eventType, this.handle, useCapture);
    }
    listenerMap[eventType] = [];
  }

  if (!selector) {
    matcherParam = null;

    // COMPLEX - matchesRoot needs to have access to
    // this.rootElement, so bind the function to this.
    matcher = matchesRoot.bind(this);

    // Compile a matcher for the given selector
  } else if (/^[a-z]+$/i.test(selector)) {
    matcherParam = selector;
    matcher = matchesTag;
  } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
    matcherParam = selector.slice(1);
    matcher = matchesId;
  } else {
    matcherParam = selector;
    matcher = Element.prototype.matches;
  }

  // Add to the list of listeners
  listenerMap[eventType].push({
    selector: selector,
    handler: handler,
    matcher: matcher,
    matcherParam: matcherParam,
  });

  return this;
};

/**
 * Remove an event handler
 * for elements that match
 * the selector, forever
 *
 * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
 * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
 * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
  let i;
  let listener;
  let listenerMap;
  let listenerList;
  let singleEventType;

  // Handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // If useCapture not set, remove
  // all event listeners
  if (useCapture === undefined) {
    this.off(eventType, selector, handler, true);
    this.off(eventType, selector, handler, false);
    return this;
  }

  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!eventType) {
    for (singleEventType in listenerMap) {
      if (listenerMap.hasOwnProperty(singleEventType)) {
        this.off(singleEventType, selector, handler);
      }
    }

    return this;
  }

  listenerList = listenerMap[eventType];
  if (!listenerList || !listenerList.length) {
    return this;
  }

  // Remove only parameter matches
  // if specified
  for (i = listenerList.length - 1; i >= 0; i--) {
    listener = listenerList[i];

    if (
      (!selector || selector === listener.selector) &&
      (!handler || handler === listener.handler)
    ) {
      this._removedListeners.push(listener);
      listenerList.splice(i, 1);
    }
  }

  // All listeners removed
  if (!listenerList.length) {
    delete listenerMap[eventType];

    // Remove the main handler
    if (this.rootElement) {
      this.rootElement.removeEventListener(eventType, this.handle, useCapture);
    }
  }

  return this;
};

/**
 * Handle an arbitrary event.
 *
 * @param {Event} event
 */
Delegate.prototype.handle = function (event) {
  let i;
  let l;
  const type = event.type;
  let root;
  let phase;
  let listener;
  let returned;
  let listenerList = [];
  let target;
  const eventIgnore = "ftLabsDelegateIgnore";

  if (event[eventIgnore] === true) {
    return;
  }

  target = event.target;

  // Hardcode value of Node.TEXT_NODE
  // as not defined in IE8
  if (target.nodeType === 3) {
    target = target.parentNode;
  }

  // Handle SVG <use> elements in IE
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  root = this.rootElement;

  phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);

  // eslint-disable-next-line default-case
  switch (phase) {
    case 1: //Event.CAPTURING_PHASE:
      listenerList = this.listenerMap[1][type];
      break;
    case 2: //Event.AT_TARGET:
      if (this.listenerMap[0] && this.listenerMap[0][type]) {
        listenerList = listenerList.concat(this.listenerMap[0][type]);
      }
      if (this.listenerMap[1] && this.listenerMap[1][type]) {
        listenerList = listenerList.concat(this.listenerMap[1][type]);
      }
      break;
    case 3: //Event.BUBBLING_PHASE:
      listenerList = this.listenerMap[0][type];
      break;
  }

  let toFire = [];

  // Need to continuously check
  // that the specific list is
  // still populated in case one
  // of the callbacks actually
  // causes the list to be destroyed.
  l = listenerList.length;
  while (target && l) {
    for (i = 0; i < l; i++) {
      listener = listenerList[i];

      // Bail from this loop if
      // the length changed and
      // no more listeners are
      // defined between i and l.
      if (!listener) {
        break;
      }

      if (
        target.tagName &&
        ["button", "input", "select", "textarea"].indexOf(
          target.tagName.toLowerCase()
        ) > -1 &&
        target.hasAttribute("disabled")
      ) {
        // Remove things that have previously fired
        toFire = [];
      }
      // Check for match and fire
      // the event if there's one
      //
      // TODO:MCG:20120117: Need a way
      // to check if event#stopImmediatePropagation
      // was called. If so, break both loops.
      else if (listener.matcher.call(target, listener.matcherParam, target)) {
        toFire.push([event, target, listener]);
      }
    }

    // TODO:MCG:20120117: Need a way to
    // check if event#stopPropagation
    // was called. If so, break looping
    // through the DOM. Stop if the
    // delegation root has been reached
    if (target === root) {
      break;
    }

    l = listenerList.length;

    // Fall back to parentNode since SVG children have no parentElement in IE
    target = target.parentElement || target.parentNode;

    // Do not traverse up to document root when using parentNode, though
    if (target instanceof HTMLDocument) {
      break;
    }
  }

  let ret;

  for (i = 0; i < toFire.length; i++) {
    // Has it been removed during while the event function was fired
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
      continue;
    }
    returned = this.fire.apply(this, toFire[i]);

    // Stop propagation to subsequent
    // callbacks if the callback returned
    // false
    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      ret = false;
      break;
    }
  }

  return ret;
};

/**
 * Fire a listener on a target.
 *
 * @param {Event} event
 * @param {Node} target
 * @param {Object} listener
 * @returns {boolean}
 */
Delegate.prototype.fire = function (event, target, listener) {
  return listener.handler.call(target, event, target);
};

/**
 * Check whether an element
 * matches a tag selector.
 *
 * Tags are NOT case-sensitive,
 * except in XML (and XML-based
 * languages such as XHTML).
 *
 * @param {string} tagName The tag name to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesTag(tagName, element) {
  return tagName.toLowerCase() === element.tagName.toLowerCase();
}

/**
 * Check whether an element
 * matches the root.
 *
 * @param {?String} selector In this case this is always passed through as null and not used
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return (
      // Match the outer document (dispatched from document)
      element === document ||
      // The <html> element (dispatched from document.body or document.documentElement)
      element === document.documentElement ||
      // Or the window itself (dispatched from window)
      element === window
    );
  }
  return this.rootElement === element;
}

/**
 * Check whether the ID of
 * the element in 'this'
 * matches the given ID.
 *
 * IDs are case-sensitive.
 *
 * @param {string} id The ID to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesId(id, element) {
  return id === element.id;
}

/**
 * Short hand for off()
 * and root(), ie both
 * with no parameters
 *
 * @return void
 */
Delegate.prototype.destroy = function () {
  this.off();
  this.root();
};

class Popup {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="open-modal"]',
      this.openModal.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="close-modal"]',
      this.closeModal.bind(this)
    );
    document.addEventListener(
      "posted_successfully",
      this.openModalSpecial.bind(this)
    );

    this.onClickOutsideListener = this.closeModal.bind(this);
  }

  openModal() {
    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add("is-visible");
    this.activeModal = document.getElementById(
      event.target.getAttribute("aria-controls")
    );
    this.activeModal.setAttribute("aria-hidden", "false");
    this.activeModal.style.display = "block";
    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
    var focus = this.element.querySelector("[data-scrollable]");

    setTimeout(() => {
      trapFocus(this.activeModal);
    }, 100);
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
  }
  openModalSpecial() {
    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add("is-visible");
    this.activeModal = document.getElementById(event.detail.id);
    this.activeModal.setAttribute("aria-hidden", "false");
    var focus = this.element.querySelector("[data-scrollable]");
    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    trapFocus(this.activeModal);
  }
  closeModal() {
    this.activeModal = document.body.querySelector(
      '.Popup[aria-hidden="false"]'
    );
    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener(
      "click",
      this.onClickOutsideListener
    );
    this.activeModal.setAttribute("aria-hidden", "true");

    bodyScrollLock.clearAllBodyScrollLocks();
    this.activeModal.removeAttribute("style");
  }
}

class RevolutionImageZoom {
  constructor(element, slideshow) {
    this.element = element;
    this.slideshow = slideshow;
    this.delegateElement = new Delegate(this.element);
    this.delegateRoot = new Delegate(document.body);
    loadScript(window.theme.pswpScript);
    this.syncHeight();
    this.bindEvents();

  }

  syncHeight(){
    document.documentElement.style.setProperty(
      "--window-inner-height",
      `${window.innerHeight}px`
    );
  }

  bindEvents() {
    window.addEventListener('resize', this.syncHeight());
    this.delegateElement.on(
      "click",
      '[data-action="open-product-zoom"]',
      this.initPhotoSwipe.bind(this)
    );
    this.delegateElement.on(
      "click",
      ".ProductSliderCell--Zoom",
      this.initPhotoSwipeFromImageClick.bind(this)
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoswiperClose.bind(this)
    );
  }
  photoswiperClose() {
    this.photoSwipeInstance.close;
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.remove("pswp-open-in-ios");
    }
  }

  initPhotoSwipe() {
    var images = [],
        index = 0;
    if(this.slideshow){
      this.slideshow.swiperElement.slides.forEach(function (item) {
        if (item.classList.contains("ProductSliderCell--Zoom")) {
          if (item.querySelector("img")) {
            images.push(item.querySelector("img"));
          }
        }
      });
      var index_currentSlide = this.slideshow.swiperElement.realIndex;
      this.slideshow.swiperElement.slides[index_currentSlide].querySelector('.ProductSlider--Element').getAttribute(
        'data-image-position'
      )
    } else {
      images.push(document.querySelector(".ProductSlider--Image"));
    }



    this.createPhotoSwipeInstance(
      this.createPhotoSwipeItemsFromImages(images),
      parseInt(index)
    );
  }

  initPhotoSwipeFromImageClick(event, target) {
    // Check if the current breakpoint is "pocket". If it is, return without doing anything.
    if (new Responsive().matchesBreakpoint('pocket')) {
      return;
    }

    // Create an array of images from the siblings of the target element.
    const images = [];
    const siblings = Array.from(target.parentElement.children);

    siblings.forEach((item) => {
      if (item.classList.contains('ProductSliderCell--Zoom') && item.querySelector('img')) {
        images.push(item.querySelector('img'));
      }
    });

    // Get the image position from the target element's data attribute.
    const imagePosition = parseInt(target.querySelector('.ProductSlider--Element').getAttribute('data-image-position'));

    // Create the PhotoSwipe instance using the images and image position.
    this.createPhotoSwipeInstance(this.createPhotoSwipeItemsFromImages(images), imagePosition);
  }

  createPhotoSwipeItemsFromImages(images) {
    return images.map(function (image) {
      var maxWidth = parseInt(image.getAttribute("data-max-width")),
        maxHeight = parseInt(image.getAttribute("data-max-height")),
        maxDimension = new Responsive().matchesBreakpoint("phone")
          ? 1200
          : 2200,
        reduceFactor = 1.0;

      if (maxWidth >= maxHeight) {
        reduceFactor = Math.max(maxWidth / maxDimension, 1.0);
      } else {
        reduceFactor = Math.max(maxHeight / maxDimension, 1.0);
      }
      var requestedWidth = Math.floor(maxWidth / reduceFactor);
      var requestedHeight = Math.floor(maxHeight / reduceFactor);
      return {
        msrc: image.currentSrc || image.src,
        w: requestedWidth,
        h: requestedHeight,
        initialZoomLevel: 0.65,
        src: image.dataset.originalSrc
      };
    });
  }

  createPhotoSwipeInstance(items, selectedImageIndex) {

    var _this = this;
    var photoswipeContainer = document.querySelector(".pswp");
    this.photoSwipeInstance = new PhotoSwipe(
      photoswipeContainer,
      false,
      items,
      {
        index: selectedImageIndex,
        showHideOpacity: true,
        showAnimationDuration: 500,
        loop: false,
        history: false,
        maxSpreadZoom: 10,
        closeOnVerticalDrag: true,
        allowPanToNext: false,
        pinchToClose: false,
        errorMsg: '<p class="pswp__error-msg"></p>',
        scaleMode: "orig",
        getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
          if (isMouseClick) {
            return 1.35;
          } else {
            return item.initialZoomLevel < 0.7 ? 1 : 1.33;
          }
        },
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var allThumbnail = _this.element.querySelectorAll(
              ".mainSwiper .ProductSliderCell--Zoom img"
            ),
            thumbnail = allThumbnail[index],
            pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        },
      }
    );

    this.photoSwipeInstance.listen(
      "beforeChange",
      this.onslideChanged.bind(this)
    );
    this.photoSwipeInstance.listen(
      "destroy",
      this.destroyPhotoSwipe.bind(this)
    );
    this.photoSwipeInstance.listen("doubleTap", this.onDoubleTap.bind(this));
    this.photoSwipeInstance.listen(
      "initialZoomIn",
      this.onInitialZoomIn.bind(this)
    );
    this.photoSwipeInstance.listen(
      "initialZoomOut",
      this.onInitialZoomOut.bind(this)
    );

    this.delegateRoot.on(
      "pswpTap",
      ".pswp__scroll-wrap",
      this.onSingleTap.bind(this)
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoSwipeInstance.close
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--prev",
      this.photoSwipeInstance.prev
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--next",
      this.photoSwipeInstance.next
    );
    this.photoSwipeInstance.listen('close', this.photoswiperClose.bind(this));
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.add("pswp-open-in-ios");
    }
    this.photoSwipeInstance.init();
  }

  onslideChanged() {
    if (this.photoSwipeInstance.getCurrentIndex() === 0) {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--prev")
        .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--prev")
        .removeAttribute("disabled");
    }

    if (
      this.photoSwipeInstance.getCurrentIndex() + 1 ===
      this.photoSwipeInstance.options.getNumItemsFn()
    ) {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--next")
        .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--next")
        .removeAttribute("disabled");
    }
  }

  onSingleTap(event) {
    if (!event.detail || event.detail.pointerType === "mouse") {
      if (event.target.classList.contains("pswp__img")) {
        this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
      }
    } else {
      if (event.target.classList.contains("pswp__button")) {
        return;
      }

      event.target
        .closest(".pswp")
        .querySelector(".pswp__ui")
        .classList.toggle("pswp__ui--hidden");
    }
  }

  onDoubleTap(point) {
    var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;

    if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
      this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
    } else {
      this.photoSwipeInstance.zoomTo(
        initialZoomLevel < 0.7 ? 1 : 1.33,
        point,
        333
      );
    }
  }

  onInitialZoomIn() {
    document.querySelector(".pswp__ui").classList.remove("pswp__ui--hidden");
  }
  onInitialZoomOut() {
    document.querySelector(".pswp__ui").classList.add("pswp__ui--hidden");
  }
  destroyPhotoSwipe() {
    this.delegateRoot.off("pswpTap");
    this.photoSwipeInstance = null;
  }
}

class RevolutionSelectbox {
  constructor(element, popover, additionalOverlay) {
    this.element = element;
    this.popover = popover;
    this.changeOverlay = additionalOverlay;
    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.dropdown = this.element.querySelector(".RevolutionSelectbox");
    this.isOpen = false;
    this.mainDropdown = this.element.querySelector(
      ".RevolutionSelectbox--Content"
    );

    this.mainDropdownContent = this.element.querySelector(
      ".RevolutionSelectbox--InnerContent"
    );
    this.mainButton = this.element.querySelector(".RevolutionSelectbox--Button");

    this.connectedSelect = this.element.getAttribute("data-select");
    this.selectbox = this.element.querySelector(
      "[name=" + this.connectedSelect + "]"
    );
    if (this.selectbox == null) {
      this.selectbox = this.element.querySelector(
        "[name2=" + this.connectedSelect + "]"
      );
    }
    if (this.popover == true) {
      this.mainDropdown.classList.remove("RevolutionSelectbox--animation");
      this.mainDropdown.classList.add("PopoverContent");
      if (this.changeOverlay) {
        this.pageOverlayElement = document.querySelector(
          ".localizationOverlay"
        );
      } else {
        this.pageOverlayElement = document.querySelector(".pageOverlay");
      }
    }
    this.bindEvents();
    this.initSelectbox();
  }

  bindEvents() {
    this.onClickOutsideListener = this.onClickOutside.bind(this);
    this.domDelegate.on(
      "click",
      "[data-action=toggle-selectbox]",
      this.toggleDropdown.bind(this)
    );

    this.domDelegate.on(
      "click",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );
    this.domDelegate.on(
      "keypress",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );

    this.domDelegate.on(
      "click",
      "[data-action=selectbox-change]",
      this.selectboxChange.bind(this)
    );

    this.delegateBody.on("menu:open", this.onClickOutside.bind(this));
    this.domDelegate.on("click", "body", this.onClickOutside.bind(this));
  }

  selectboxChange() {
    var value = event.target.getAttribute("data-value");
    var selectboxID = event.target.getAttribute("data-selectboxid");
    var innerContent = event.target.innerHTML;
    var selEl = this.element.querySelector("#" + selectboxID);
    if (selEl.nodeName == "SELECT") {
      selEl.value = value;
      selEl.dispatchEvent(new Event("change"));
    } else {
      selEl
        .querySelector('[value="' + value + '"]')
        .setAttribute("checked", "true");
    }
    this.mainButton.querySelector(".RevolutionSelectbox--Title").innerHTML =
      innerContent;

    if(this.element.classList.contains('dropdownSelector')){
      this.element.querySelector('.RevolutionSelectbox--Item[disabled="true"]').removeAttribute('disabled');
      event.target.setAttribute('disabled','true');
    }
    this.closeDropdown(this.element);
  }

  onClickOutside(event) {
    const withinBoundaries = event.composedPath().includes(this.element);
    if (
      !withinBoundaries ||
      event.target.classList.contains("FiltersDesktopWrapper")
    ) {
      this.closeDropdown(this.element);
    }
  }

  selectboxSubmit(event) {
    if (event.key != "Enter" && event.key !== undefined) {
      return;
    }
    var value = event.target.getAttribute("data-value");
    var dataName = event.target.getAttribute("data-name");
    this.selectbox.value = value;
    this.closeDropdown(this.element);
    this.mainButton.querySelector(".RevolutionSelectbox--Title").innerHTML =
      dataName;
    this.selectbox.parentElement.submit();
  }

  initSelectbox() {
    const selectedItem = this.mainDropdown.querySelector('[selected="selected"]'),
      titleElement = this.element.querySelector(".RevolutionSelectbox--Title");
    if (selectedItem) {
      titleElement.innerHTML = selectedItem.getAttribute("data-name");
      }



    trapFocus(this.element);
    this.element.style.display = "block";
  }

  toggleDropdown(event, target) {
    event.preventDefault();


    if (this.isOpen) {
      this.closeDropdown(target);
    } else {
      this.openDropdown(target);
    }
  }

  openDropdown(target) {
    // Dispatch "close:search" and "menu:close" events on the element.
    this.element.dispatchEvent(new CustomEvent('close:search', { bubbles: true }));


    // Find all siblings with class ".RevolutionSelectbox".
    const siblings = Array.from(target.parentElement.parentElement.children)
      .filter((item) => item.classList.contains('RevolutionSelectbox'));

    // Hide the dropdown content for all siblings.
    siblings.forEach((item) => {
      item.querySelector('.RevolutionSelectbox--Button').setAttribute('aria-expanded', false);
      item.querySelector('.RevolutionSelectbox--Content').setAttribute('aria-hidden', true);
      item.querySelector('.RevolutionSelectbox--Content').style.display = 'none';
    });

    // If the dropdown is a popover, show the page overlay and disable body scrolling.
    if (this.popover) {
      this.pageOverlayElement.classList.add('is-visible');
      this.pageOverlayElement.addEventListener('click', this.onClickOutsideListener);
      const focus = this.element.querySelector('[data-scrollable]');
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
      document.body.classList.add('scrollLock');
      trapFocus(this.mainDropdown);
      if (document.querySelector('#Drawer').getAttribute('aria-expanded') === 'true') {
        document.querySelector('.Drawer--Wrapper').style.overflow = 'visible';
      }
    } else {
      this.element.dispatchEvent(new CustomEvent('menu:close', { bubbles: true }));
    }

    // Show the dropdown content for the target element and set its state to "expanded".
    const contentElement = target.parentElement.querySelector('.RevolutionSelectbox--Content');
    target.setAttribute('aria-expanded', 'true');
    contentElement.style.display = 'block';
    contentElement.style.height = `${contentElement.offsetHeight}px`;

    if (this.popover){
      setTimeout(() => {
        contentElement.setAttribute('aria-hidden', 'false');
      }, 20);
    } else {
        contentElement.setAttribute('aria-hidden', 'false');
    }


    this.isOpen = true;
    window.addEventListener('click', this.onClickOutsideListener);
  }

  closeDropdown(target) {
    var closestDropdown = target.closest(".RevolutionSelectbox");
    if (closestDropdown === null) {
      var closestDropdown = target.querySelector(
        "[aria-expanded='true']"
      ).parentElement;
    }
    closestDropdown
      .querySelector(".RevolutionSelectbox--Button")
      .setAttribute("aria-expanded", false);
    closestDropdown
      .querySelector(".RevolutionSelectbox--Content")
      .setAttribute("aria-hidden", true);
    setTimeout(() => {
      closestDropdown.querySelector(
        ".RevolutionSelectbox--Content"
      ).style.display = "none";
    }, 300);

    if (this.popover == true) {
      this.pageOverlayElement.classList.remove("is-visible");
      this.pageOverlayElement.removeEventListener(
        "click",
        this.onClickOutsideListener
      );

      const menuDrawer = document.querySelector('#Drawer');
      if(menuDrawer.getAttribute('aria-expanded') == "true"){
        document.querySelector('.Drawer--Wrapper').style.overflow = "auto";
      }else{
        bodyScrollLock.clearAllBodyScrollLocks();
        document.body.classList.remove("scrollLock");
      }


    }
    this.isOpen = false;
    removeTrapFocus(this.mainDropdownContent);
    window.removeEventListener("click", this.onClickOutsideListener);
  }
}

class Form {
  constructor() {}

  serialize(form) {
    function stringKey(key, value) {
      var beginBracket = key.lastIndexOf("[");

      if (beginBracket === -1) {
        var _hash = {};
        _hash[key] = value;
        return _hash;
      }

      var newKey = key.substr(0, beginBracket);
      var newValue = {};

      newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

      return stringKey(newKey, newValue);
    }

    var hash = {};

    for (var i = 0, len = form.elements.length; i < len; i++) {
      var formElement = form.elements[i];

      if (formElement.name === "" || formElement.disabled) {
        continue;
      }

      if (
        formElement.name &&
        !formElement.disabled &&
        (formElement.checked ||
          /select|textarea/i.test(formElement.nodeName) ||
          /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
            formElement.type
          ))
      ) {
        var stringKeys = stringKey(formElement.name, formElement.value);
        hash = this.extend(hash, stringKeys);
      }
    }

    return hash;
  }
  extend() {
    var extended = {},
        i = 0,
        _this = this;

    // Merge the object into the extended object
    var merge = function merge(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          // If property is an object, merge properties
          if (Object.prototype.toString.call(obj[prop]) === "[object Object]") {
            extended[prop] = _this.extend(extended[prop], obj[prop]);
          } else {
            extended[prop] = obj[prop];
          }
        }
      }
    };

    // Loop through each object and conduct a merge
    for (; i < arguments.length; i++) {
      merge(arguments[i]);
    }

    return extended;
  }
}

class AddToCart {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action=add-to-cart]",
      this.addToCart.bind(this)
    );

  }

  addToCart() {

    var _this = this;
    event.preventDefault();
    var addToCartButton = event.target;
    this.pageLoader.style.width = 100 + "%";
    addToCartButton.setAttribute("disabled", "disabled");
    var formElement = event.target.closest("form");
    formElement.querySelector('[name="id"]').removeAttribute("disabled");
    var formHelper = new Form();
    const serialized = formHelper.serialize(formElement);

    fetch(window.routes.localeRootUrl + "/cart/add.js", {
      body: JSON.stringify(serialized),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {

        if (window.location.href.indexOf("cart") != -1){
          location.reload();
          return;
        }
        addToCartButton.removeAttribute("disabled");
        _this.element.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              variant: serialized.id,
              quantity: serialized.quantity,
            },
          })
        );

      } else {
        response.json().then(function (content) {
          if (_this.element.querySelector(".ProductForm--Error")) {
            _this.element
              .querySelector(".ProductForm--Error")
              .classList.add("visible");
            setTimeout(function () {
              _this.element
                .querySelector(".ProductForm--Error")
                .classList.remove("visible");
            }, 2500);
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);
          } else {
            var errorMessageElement = document.createElement("span");
            errorMessageElement.className = "u-p4 accent";
            errorMessageElement.innerHTML = content["description"];
            addToCartButton.removeAttribute("disabled");
            addToCartButton.insertAdjacentElement(
              "afterend",
              errorMessageElement
            );
            setTimeout(function () {
              errorMessageElement.remove();
            }, 2500);
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);
          }
        });
      }
    });
  }
}
/*GLOBAL FUNCTIONS */

function handleFirstTab(e) {
  if (e.keyCode === 9) {
    document.body.classList.add("user-is-tabbing");

    window.removeEventListener("keydown", handleFirstTab);
    window.addEventListener("mousedown", handleMouseDownOnce);
  }
}

function handleMouseDownOnce() {
  document.body.classList.remove("user-is-tabbing");

  window.removeEventListener("mousedown", handleMouseDownOnce);
  window.addEventListener("keydown", handleFirstTab);
}

window.addEventListener("keydown", handleFirstTab);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .focusable"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  if (first) {
    first.focus();
  } else {
    elementToFocus.focus();
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class Responsive {
  constructor() {
    var _this = this;
    this.currentBreakpoint = this.getCurrentBreakpoint();
    window.addEventListener("resize", function () {
      var newBreakpoint = _this.getCurrentBreakpoint();
      if (_this.currentBreakpoint === newBreakpoint) {
        return;
      }
      document.dispatchEvent(
        new CustomEvent("breakpoint:changed", {
          detail: {
            previousBreakpoint: _this.currentBreakpoint,
            currentBreakpoint: newBreakpoint,
          },
        })
      );
      _this.currentBreakpoint = newBreakpoint;
    });
  }
  matchesBreakpoint(breakpoint) {
    switch (breakpoint) {
      case "pocket":
        return window.matchMedia("screen and (max-width: 1024px)").matches;
      case "lap-and-up":
        return window.matchMedia("screen and (min-width: 1025px)").matches;
    }
  }
  getCurrentBreakpoint() {
    if (window.matchMedia("screen and (max-width: 1024px)").matches) {
      return "pocket";
    }
    if (window.matchMedia("screen and (min-width: 1025px)").matches) {
      return "lap-and-up";
    }
  }
}

class Dropdown {
  constructor() {

    this.domDelegate = new Delegate(document.body);
    this.breakpoint = new Responsive().getCurrentBreakpoint();
    this.bindEvents();
  }
  bindEvents() {

    // Bind event for general dropdown toggle
    this.domDelegate.on(
      "click",
      "[data-action=toggle-dropdown]",
      this.toggleDropdown.bind(this)
    );

    let selector;
    switch (this.breakpoint) {
      case 'lap-and-up':
        // For lap-and-up breakpoint, bind event for desktop dropdown toggle
        selector = "[data-action=toggle-desktop-dropdown]";
        break;
      case 'pocket':
        // For pocket breakpoint, bind event for mobile dropdown toggle
        selector = "[data-action=toggle-mobile-dropdown]";
        break;
      default:
        // If no specific breakpoint, set selector as false to skip binding
        selector = false;
        break;
    }

    if (selector) {
      // Bind event for specific breakpoint dropdown toggle
      this.domDelegate.on(
        "click",
        selector,
        this.toggleDropdown.bind(this)
      );
    }

  }
  openDropdown(elem) {
    // Open the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");

    DropdownButton.setAttribute("aria-expanded", true);
    new RevolutionAnimation(DropdownContent, "true").slideDown();
    DropdownContent.setAttribute("aria-hidden", "false");
  }

  closeDropdown(elem) {
    const DropdownButton = elem.querySelector(".Dropdown--Button"),
      DropdownContent = elem.querySelector(".Dropdown--Content");
     new RevolutionAnimation(DropdownContent, "false").slideUp();
    DropdownButton.setAttribute("aria-expanded", false);
    DropdownButton.style.pointerEvents = "none";
    setTimeout(function () {
      DropdownContent.setAttribute("aria-hidden", "true");
      DropdownButton.style.pointerEvents = "all";
    }, 250);
  }

  toggleDropdown(event, target) {

    event.preventDefault();
    const mainDropdown = target.closest(".Dropdown");
    const isOpen = target.getAttribute("aria-expanded") === "true";
    if (isOpen) {
      // If dropdown is open, close it
      this.closeDropdown(mainDropdown, target);
    } else {
      // If dropdown is closed, open it
      this.openDropdown(mainDropdown, target);
    }
  }
}
new Dropdown();

class RevolutionSwiper {
  constructor(element, additionalSwiper) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.thumb = additionalSwiper;
    this.initialConfig = JSON.parse(
      element.getAttribute("data-swiper-settings")
    );

    if (additionalSwiper) {
      this.initialConfigThumbs = JSON.parse(
        additionalSwiper.getAttribute("data-swiper-thumb-settings")
      );
    }
    this.options = options;
    this.build();
  }

  selectCell(index) {
    console.log('palim se', index);
    this.swiperElement.slideTo(index);
  }

  resize() {
    this.swiperElement.resize();
  }

  build() {
    var _this = this,
      configThumb = this.initialConfigThumbs;
    if (configThumb != null) {
      this.thumbSwiper = new Swiper(this.thumb, configThumb);
      this.initialConfig.thumbs["swiper"] = this.thumbSwiper;
    }

    this.swiperElement = new Swiper(this.element, this.initialConfig);
    this.selectedIndex = this.swiperElement.activeIndex;

    this.swiperElement.on("slideChange", function () {

      _this.element.dispatchEvent(
        new CustomEvent("swiper:slide-changed", {
          bubbles: true,
          detail: {
            currentIndex: _this.swiperElement.activeIndex,
            element: _this.swiperElement.el[0],
          },
        })
      );
    });


  }
}

class Drawer {
  constructor(element) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pageOverlayElement = document.querySelector(".pageOverlay");

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );
    this.onOpen = options["onOpen"] || function () {};
    this.onClose = options["onClose"] || function () {};
    this.isOpen = false;
    this.wasTransparent = false;
    


     this.maxHeight();
    this.bindEvents();
  }

  bindEvents() {

    this.delegateBody.on(
      "click",
      '[data-action="open-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.openDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="close-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.closeDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="toggle-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.toggleDrawer.bind(this)
    );

    document.addEventListener("scroll", (event) => {
      this.maxHeight();
    })


    this._openListener = this.openDrawer.bind(this);
    this._closeListener = this.closeDrawer.bind(this);
    this.calculateMaxHeightListener = this.maxHeight.bind(this);
    window.addEventListener("resize", this.calculateMaxHeightListener);

    this.delegateBody.on("cart-drawer:close-other", this._closeListener);

    this.delegateBody.on("menu:close", this._closeListener);

  }



  maxHeight() {
    const id = this.element.getAttribute("id");
    if (id == "quantityDrawer") {
      return;
    }
    this.element.style.height = window.innerHeight + "px";
    if (id == "cart" || id == "sidebarFavorites") {
      var footer = this.element.querySelector(".CartDrawer--Footer");
      var footerHeight = 0;
      if (footer !== null) {
        footerHeight = footer.offsetHeight;
      }

      var header = this.element.querySelector(".CartHeader").offsetHeight;
      document.documentElement.style.setProperty("--cartHeader-height", header + "px");
      var cartItem = this.element.querySelector(".cartItem");
      if (cartItem !== null) {
        var itemHeight = cartItem.offsetHeight;
      }

      var itemWrapper = this.element.querySelector(".CartItems--Wrapper");


      if (itemWrapper !== null) {
        itemWrapper.style.height =
          window.innerHeight - footerHeight - header  + "px";
      }
    } else if (id == "Drawer") {
       
      const headerHeight = document.querySelector('#shopify-section-main-header').offsetHeight;

       const announcementBar = document.querySelector('.announcementBar');
      const visibleHeight = this.calculateVisibleHeight(announcementBar);
     
      

      let difference = headerHeight + visibleHeight ;
      if(document.body.classList.contains('bodyScrolled')){
        difference = headerHeight;
      }


      this.element.style.height = `${window.innerHeight - difference }px`;
      
    } else {
      var filterBar = document.querySelector(".FilterBar");
      var mobileHeader = document.querySelector(".header");
      var breakpoint = new Responsive().getCurrentBreakpoint();

      if (filterBar !== null && breakpoint == "phone") {
        var filterBarHeight = filterBar.offsetHeight;
        var mobileHeaderHeight = mobileHeader.offsetHeight;

        this.element.style.height =
          window.innerHeight  + "px";
      }
    }
  }

  toggleDrawer() {
    event.preventDefault();

    this.isOpen ? this.closeDrawer() : this.openDrawer();
  }

  calculateVisibleHeight(element) {
    if( element != null){
        const rect = element.getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;

        const top = Math.max(rect.top, 0);
        const bottom = Math.min(rect.bottom, windowHeight);

        return Math.max(bottom - top, 0);
    }
}

  openDrawer() {
    this.maxHeight();
    var drawerId = this.element.getAttribute("id");

    this.element.dispatchEvent(
      new CustomEvent("close:search", { bubbles: true })
    );

    if (drawerId == "cart") {
      this.element.dispatchEvent(
        new CustomEvent("cart-drawer:open", { bubbles: true })
      );
      if (this.element.querySelector(".emptyItem--Text")) {
        this.element.querySelector(".emptyItem--Text").style.display = "flex";
      }


      if (this.element.querySelector(".emptyItem--Text")) {
        this.element.querySelector(".emptyItem--Text").style.display = "flex";
      }


      setTimeout(() => {
        var count = window.theme.cartCount;
        var options = JSON.parse(this.element.getAttribute("data-settings"));
      }, 200);
    }
    if (this.isOpen) {
      return;
    }

    this.element.dispatchEvent(
      new CustomEvent("cart-drawer:close-other", { bubbles: true })
    );

    this.maxHeight();

    if (drawerId == "Drawer") {
       const announcementBar = document.querySelector('.announcementBar');
      const visibleHeight = this.calculateVisibleHeight(announcementBar);
      const headerHeight = header.offsetHeight;
      

      this.element.style.top = visibleHeight + headerHeight + "px";
      if (document.querySelector(".SidebarDrawer__Close")) {
        document.querySelector(".SidebarDrawer__Close").style.display = "block";
      }
      document.querySelector('#mobile-menu').classList.toggle('is-active');
      document.body.querySelector("#shopify-section-main-header").style.zIndex =
        "99";
        if(document.body.querySelector("#header").classList.contains('Header--Transparent')){
          document.body.querySelector("#header").classList.remove('Header--Transparent');
          this.wasTransparent = true;
        }


      this.element.dispatchEvent(
        new CustomEvent("sidebar-drawer:open", {
          bubbles: true,
        })
      );
    } else if (drawerId == "favoritesDrawer") {
      this.element.dispatchEvent(
        new CustomEvent("favorite-product:open", {
          bubbles: true,
        })
      );

    } else if (drawerId == "FilterDrawer" || drawerId == "sortby") {
      document.querySelector(".FilterBar").style.zIndex = "99";
      document.body.querySelector("#shopify-section-main-header").style.zIndex =
        "99";

    }

    this.element.setAttribute("aria-expanded", "true");
    this.pageOverlayElement.classList.add("is-visible");
    this.pageOverlayElement.addEventListener("click", this._closeListener);


    var focus = this.element.querySelectorAll("[data-scrollable]");
    focus.forEach((item) => {
      bodyScrollLock.disableBodyScroll(item);
    });
    document.body.classList.add("scrollLock");
    this.isOpen = true;
    setTimeout(() => {
      trapFocus(this.element);
    }, 400);
    this.onOpen();
    return false;
  }

  closeDrawer(event) {
    if (!this.isOpen) {
      return;
    }

    var drawerId = this.element.getAttribute("id");
    if (event) {
      event.preventDefault();
    }
    if (drawerId == "Drawer") {

      this.maxHeight();
      document.querySelector('#mobile-menu').classList.toggle('is-active');
      if (this.wasTransparent == true){
        document.body.querySelector("#header").classList.add('Header--Transparent');

      }
    }
    if (
      drawerId == "favoritesDrawer" &&
      this.element.querySelector(".swiperFavorites--titleButtons")
    ) {
      this.element.querySelector(
        ".swiperFavorites--titleButtons"
      ).style.display = "none";
      if (this.element.querySelector(".favUpsell__Container")) {
        this.element.querySelector(".favUpsell__Container").remove();
      }
    }

    document.body.classList.remove("scrollLock");

    bodyScrollLock.clearAllBodyScrollLocks();
    if (drawerId == "cart") {
      var options = JSON.parse(this.element.getAttribute("data-settings"));
    }
    this.element.setAttribute("aria-expanded", "false");
    if (
      this.element.classList.contains("sizeDrawer_Wrapper") == true &&
      document.body.querySelector("#cart").getAttribute("aria-expanded") ==
        "true"
    ) {
      return;
    }


    if (
      drawerId == "FilterDrawer" ||
      drawerId == "sidebarDrawer" ||
      drawerId == "sortby"
    ) {
      document.body.querySelector("#shopify-section-header").style.zIndex = "6";
    }


    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener("click", this._closeListener);
    removeTrapFocus(this.element);
    this.closeAnimation(this.element);
    this.isOpen = false;
    this.onClose();
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

class RevolutionAnimation {
  constructor(element, directAnimation) {
    this.element = element;
    if (!directAnimation) {
      this.intersectionObserver = [];
      this.integer = 0;
      var contentToAnimate = document.querySelectorAll("[data-animation]");
      contentToAnimate.forEach((item, i) => {
        this.animateElement(item, i);
        this.integer = this.integer + 1;
      });
  
      // Listen for changes to the DOM and animate any new elements
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const newContentToAnimate = node.querySelectorAll("[data-animation]");

              newContentToAnimate.forEach((item, i) => {
                this.animateElement(item, this.integer);
                this.integer = this.integer + 1;
              });
            }
          });
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

 slideUp() {
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.offsetHeight;
    this.element.style.height = 0;
  }
  slideDown() {
    if (this.element.style.height === "auto") {
      return;
    }
    var _this = this;
    this.element.style.pointerEvents = "none";
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.setAttribute("aria-hidden", false);
    var transitionEnded = function transitionEnded(event) {
      if (event.propertyName === "height") {
        _this.element.style.pointerEvents = "all";
        _this.element.style.height = "auto";
        _this.element.removeEventListener("transitionend", transitionEnded);
      }
    };
    this.element.addEventListener("transitionend", transitionEnded);
  }

// A function to animate a list of elements by scaling them out
 elementScaleOut(elements) {
  // Get the animation duration and delay from the theme settings
  const animationDuration = window.theme.animationDuration * 2;
  const animationDelay = window.theme.animationBetweenElements;

  // Loop through each element in the list
  elements.forEach((element, index) => {
    // Check if the element has already been loaded
    if (element.hasAttribute("data-loaded")) {
      // If so, skip this element
      return;
    }

    // Mark the element as loaded to prevent duplicate animations
    element.setAttribute("data-loaded", true);

    // Define the animation keyframes
    const keyframes = [
      { transform: "scale(104%)", opacity: "0" },
      { transform: "scale(100%)", opacity: "1" },
    ];

    // Define the animation options
    const animationOptions = {
      duration: animationDuration,
      fill: "forwards",
    };

    // Schedule the animation with a delay based on the element's position in the list
    setTimeout(() => {
      element.animate(keyframes, animationOptions);
    }, animationDelay * index);
  });
}



  elementScaleIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "scale(96%)", opacity: "0" },
          { transform: "scale(100%)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration * 2,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromTop(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(-30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromBottom(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromRight(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromLeft(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(-30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromRightBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromLeftBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(-120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  imageHeightTopToBottom(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }

      setTimeout(() => {
        var elementMove = [
          // keyframes
          { height: "0", opacity:1}
        ];
        item.animate(elementMove, {
          // timing options
          duration: 1000,
          fill: "forwards",
          easing: "cubic-bezier(0.39, 0.58, 0.57, 1)"
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  imageUnravel(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        item.classList.add("show");
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  sectionFromCentre(toReveal){
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
          item.classList.add("BlogModule--animation");
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  animateElement(animatedItem, index) {

    const options = {
      integer: index,
      type: animatedItem.dataset.animation,
    };

    if (this.intersectionObserver[index]) {
      this.intersectionObserver[index].disconnect();
    }

    this.intersectionObserver[index] = new IntersectionObserver(
      (results) => {
        const integer = options.integer;
        const elements = [];

        // Iterate over the IntersectionObserverEntry objects in the results array.
        results.forEach((result) => {
   
          // Check if the target element is intersecting the root element or if its intersection ratio is greater than 0.
          if (result.isIntersecting || result.intersectionRatio > 0) {
            // Add the target element to the elements array.
            elements.push(result.target);
            // Unobserve the target element.
            this.intersectionObserver[integer].unobserve(result.target);
          }
        });

        // If there are no elements to reveal, return.
        if (elements.length === 0) {
          return;
        }

        // An object that maps each animation type to the corresponding animation function.
        const animations = {
          elementFromTop: 'elementFromTop',
          elementFromBottom: 'elementFromBottom',
          elementFromRight: 'elementFromRight',
          elementFromLeft: 'elementFromLeft',
          elementFromLeftBig: 'elementFromLeftBig',
          elementFromRightBig: 'elementFromRightBig',
          elementScaleIn: 'elementScaleIn',
          elementScaleOut: 'elementScaleOut',
          imageHeightTopToBottom: 'imageHeightTopToBottom',
          imageUnravel: 'imageUnravel',
          sectionFromCentre: 'sectionFromCentre'
        };

        // Get the animation function corresponding to the type from the animations object.
        const animation = animations[options.type];
        // If the animation function exists, call it with the elements array.
        if (animation) {
          this[animation](elements);
        }
      },
      { threshold: 0.25 }
    );
  
    if (animatedItem.classList.contains('animatedContent')){
      this.intersectionObserver[index].observe(animatedItem);
    }

    animatedItem.querySelectorAll('.animatedContent').forEach((item) => {
      this.intersectionObserver[index].observe(item);
    });

  }
}

if(window.theme.enableAnimations){
  document.addEventListener("DOMContentLoaded", function() {
    new RevolutionAnimation();
  });
}


class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.input = this.querySelector("input");
    this.changeEvent = new Event("quantity:changed", { bubbles: true });
    this.options = JSON.parse(this.element.getAttribute("data-settings"));

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

      if (this.options['noVariants'] == "true"){
       /*  this.toggleAddButton(); */
      }
  }


  toggleAddButton() {
    let quantity = "";
    const addButton = document.querySelector(".ProductPage--ATC"),
          addButtonInner = addButton.querySelector(".SelfAlign"),
          quantityEl = document.querySelector('.QuantitySelector__ProductQuantity');
    if(quantityEl){
      quantity = quantityEl.value();
    }
    if (window.variantInfo.show_icon) {
      var buySvg =
        '<svg class="Svg Svg--shopping_cart mr-m" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M25.31 5.19547C25.1687 5.02127 24.9568 4.91946 24.7325 4.91797H9.11751L9.60501 6.41797H23.75L21.7475 15.418H10.4975L7.07001 4.56547C6.99476 4.33174 6.80986 4.14965 6.57501 4.07797L3.50001 3.13297C3.24278 3.05393 2.96292 3.11812 2.76584 3.30137C2.56877 3.48461 2.48443 3.75907 2.54459 4.02137C2.60476 4.28366 2.80028 4.49393 3.05751 4.57297L5.75001 5.39797L9.19251 16.273L7.96251 17.278L7.86501 17.3755C7.2374 18.0987 7.21221 19.1659 7.80501 19.918C8.21952 20.4221 8.84817 20.7002 9.50001 20.668H22.0175C22.4317 20.668 22.7675 20.3322 22.7675 19.918C22.7675 19.5038 22.4317 19.168 22.0175 19.168H9.38001C9.20436 19.162 9.0446 19.0646 8.95873 18.9113C8.87286 18.7579 8.87334 18.5709 8.96001 18.418L10.7675 16.918H22.3475C22.705 16.9267 23.0189 16.6818 23.0975 16.333L25.475 5.83297C25.5212 5.6064 25.4603 5.37117 25.31 5.19547ZM20.75 25.168C21.682 25.168 22.4375 24.4125 22.4375 23.4805C22.4375 22.5485 21.682 21.793 20.75 21.793C19.818 21.793 19.0625 22.5485 19.0625 23.4805C19.0625 24.4125 19.818 25.168 20.75 25.168ZM12.185 23.4805C12.185 24.4125 11.4295 25.168 10.4975 25.168C9.56553 25.168 8.81001 24.4125 8.81001 23.4805C8.81001 22.5485 9.56553 21.793 10.4975 21.793C11.4295 21.793 12.185 22.5485 12.185 23.4805Z" fill="#121212"></path></svg>';
    } else {
      var buySvg = "";
    }

    if (!addButton) return;
    if (!quantity){quantity = 1;}


      addButton.removeAttribute("disabled");
      addButton.classList.remove("ProductCard--Sold__Out");
      if (window.variantInfo.show_price) {
        var priceElement =
          "<span class='u-p3 ml-s'>" +
          Shopify.formatMoney(
            this.options['price'] * quantity,
            window.theme.moneyFormat
          );
        +"</span>";
      } else {
        var priceElement = "";
      }

      addButtonInner.innerHTML =
        buySvg + window.variantStrings.addToCart + priceElement;

  }

}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ProductForm extends HTMLElement {
  constructor() {
    super();
    new AddToCart(this);
  }
}

customElements.define("product-form", ProductForm);

class Countdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.counter = 0;
    this.counter = this.element.querySelector(".component-countDown");
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    setInterval(this.countDown.bind(this), 1000);
  }

  countDown() {
    const dateNow = new Date();
    const countDate = new Date(
      "March 3, 2030," + this.options["countdownTime"]
    );
    const nOfDays = this.options["countdownDays"];
    const difference = countDate - dateNow;

    var textDays = 0;
    const seconds = 1000;
    const minutes = seconds * 60;
    const hours = minutes * 60;
    const days = hours * 24;
    const todaysDay = dateNow.getDay();

    const textHours = Math.floor((difference % days) / hours);
    const textMinutes = Math.floor((difference % hours) / minutes);
    const textSeconds = Math.floor((difference % minutes) / seconds);

    if (todaysDay == 1) {
      textDays = nOfDays;
    } else if (todaysDay == 0) {
      textDays = 0;
    } else {
      textDays = nOfDays - todaysDay;
      if (textDays < 0) {
        const mDays = todaysDay % nOfDays;
        textDays = nOfDays - mDays;
      }
    }

    if (this.options["excludeWeekends"] && todaysDay == 5) {
      textDays = textDays + 2;
    } else if (this.options["excludeWeekends"] && todaysDay == 6) {
      textDays = textDays + 1;
    }

    const displayHours = textHours;
    const formatHours = displayHours < 10 ? `0${displayHours}` : displayHours;
    const formatMinutes = textMinutes < 10 ? `0${textMinutes}` : textMinutes;
    const formatSeconds = textSeconds < 10 ? `0${textSeconds}` : textSeconds;
    if (textDays > 0 && nOfDays > 1) {
      this.counter.innerText = `${textDays}d ${formatHours}:${formatMinutes}:${formatSeconds}`;
    } else {
      this.counter.innerText = `${formatHours}:${formatMinutes}:${formatSeconds}`;
    }
  }
}
customElements.define("countdown-element", Countdown);

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.sidebarDrawer = new Drawer(this.element);
    this.loader = this.element.querySelector(".itemLoader");
   this.cartCount = document.querySelector(".CartCount");
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.breakpoint = new Responsive().getCurrentBreakpoint();
    new AddToCart(this.element);

    this.bindEvents();
  }
  onUnload() {
    this.delegateElement.off();
    document.removeEventListener("product:added", this.onProductAddedListener);
  }
  bindEvents() {
    if (window.theme.listener == "false") {
      this.onProductAddedListener = this.onProductAdded.bind(this);
      document.addEventListener("cart-drawer:open", this.onOpen.bind(this));
      document.addEventListener("product:added", this.onProductAddedListener);
      this.delegateElement.on(
        "click",
        '[data-action="update-item-quantity"], [data-action="remove-item"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "change",
        '[data-action="update-change-quantity"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "quantity:changed",
        ".QuantitySelector__CurrentQuantity",
        this.updateItemQuantity.bind(this)
      );

      window.theme.listener = "true";
    }
  }
  onOpen() {
    // Get the value of the aria-expanded attribute.
    const isExpanded = this.element.getAttribute("aria-expanded") === "true";

    // Early exit if the drawer is already expanded.
    if (isExpanded) {
      return;
    }

    // Calculate the height of the cart header and free shipping elements.
    const cartHeader = document.querySelector(".CartHeader");

    const cartHeaderHeight = cartHeader ? cartHeader.offsetHeight : 0;

    let totalHeight = cartHeaderHeight;

    // Set the height of the cart header using a CSS variable.
    /* if(window.theme.cartCount > 0 ){
       totalHeight = cartHeaderHeight;
    }  */
    document.documentElement.style.setProperty("--cartHeader-height", totalHeight + "px");
    // Load recommendations if the option is enabled.
    if (this.options.showRecommendations) {
      this.loadRecommendations();
    }
  }

  updateItemQuantity(event, target) {
    event.preventDefault();
    target
      .closest(".cartItem")
      .querySelector(".itemLoader")
      .classList.add("is-visible");
    var _this = this;

    var quantity = null;
    if (target.tagName === "INPUT") {
      quantity = parseInt(Math.max(parseInt(target.value) || 0, 0));
    } else {
      quantity = parseInt(target.getAttribute("data-quantity"));
    }

    fetch(window.routes.localeRootUrl + "/cart/change.js", {
      body: JSON.stringify({
        id: target.getAttribute("data-line-id"),
        quantity: quantity,
      }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function () {
      _this.renderCart(target.getAttribute("data-id"), true);
    });
  }

  onProductAdded() {
    var _this = this;
    this.renderCart().then(function () {
      _this.sidebarDrawer.openDrawer();
    });
  }

  renderCart(lineNumber, quantityChange) {
    this.pageLoader.style.width = 100 + "%";

    var _this = this;

    return fetch(window.routes.localeRootUrl + "/?section_id=main-cart_drawer", {

      credentials: "same-origin",
      method: "GET",
    }).then(function (content) {
      content.text().then(function (html) {

        _this.replaceContent(html, lineNumber, quantityChange);
      });
    });
  }

  replaceContent(html, lineNumber, quantityChange) {
    var _this = this;
    this.pageLoader.style.left = "unset";
    this.pageLoader.style.right = 0 + "px";
    this.pageLoader.style.width = 0 + "%";
    setTimeout(() => {
      this.pageLoader.style.left = 0 + "px";
      this.pageLoader.style.right = "unset";
    }, 550);
    var tempElement = document.createElement("div");
    tempElement.innerHTML = html;

    this.tempOptions = JSON.parse(
      tempElement.querySelector("#cart").getAttribute("data-settings")
    );



    var number = this.tempOptions["itemCount"];
    this.cartCount.innerHTML = `(${number})`;
    if (number > 0){
      document.querySelector('.fullHeaderIcon').setAttribute('aria-hidden','false');
      document.querySelector('.emptyHeaderIcon').setAttribute('aria-hidden','true');
    } else {
      document.querySelector('.fullHeaderIcon').setAttribute('aria-hidden','true');
      document.querySelector('.emptyHeaderIcon').setAttribute('aria-hidden','false');
    }
    window.theme.cartCount = parseInt(number);

    if (lineNumber) {
      var cartNodeParent = this.element.querySelector("#" + lineNumber);
      const itemToReplaceWith = tempElement.querySelector(
        "#" + lineNumber + " .cartItem--Informations"
      );
      if (cartNodeParent.querySelector(".itemLoader")) {
        cartNodeParent
          .querySelector(".itemLoader")
          .classList.remove("is-visible");
      }
      if (itemToReplaceWith) {
        cartNodeParent.replaceChild(
          itemToReplaceWith,
          cartNodeParent.querySelector(".cartItem--Informations")
        );
      } else {
        cartNodeParent.classList.add("removing");
        cartNodeParent.animate(
          [
            // keyframes
            { transform: "translateY(0px)", opacity: "1" },
            { transform: "translateY(30px)", opacity: "0" },
          ],
          {
            // timing options
            duration: 500,
            fill: "forwards",
          }
        );
        setTimeout(() => {
          cartNodeParent.remove();
        }, 500);

        if (this.options["showRecommendations"]) {
          this.loadRecommendations();
        }
      }

      if (number > 0) {
        const checkoutButtonParent = this.element.querySelector(
          ".CartDrawer--Footer"
        );
        const checkoutButtonToReplace = tempElement.querySelector(
          ".CartFooter--Totals"
        );
        const checkoutMetaParent = checkoutButtonParent.querySelector('.MetaIcon--Wrappers');
        if (checkoutMetaParent) {
          checkoutMetaParent.replaceChild(
            checkoutButtonToReplace,
            checkoutButtonParent.querySelector(".CartFooter--Totals")
          );
        }
      } else {
        this.element
          .querySelector(".CartDrawer--Footer")
          .classList.add("removing");

        const mainPartParent = this.element.querySelector(".CartDrawer");

        mainPartParent.innerHTML =
          tempElement.querySelector(".CartDrawer").innerHTML;

        if (window.theme.enableAnimations) {
          const mainPartchildren =
            mainPartParent.querySelector("#main-cartItems");
          mainPartchildren.animate(
            [
              // keyframes
              { opacity: "0" },
              { opacity: "1" },
            ],
            {
              // timing options
              duration: 500,
              fill: "forwards",
            }
          );
        }
      }
      if (this.element.querySelector(".itemLoader")) {
        setTimeout(() => {
          this.element
            .querySelector(".itemLoader")
            .classList.remove("is-visible");
        }, 250);
      }
    } else {
      const cartNodeParent =
        this.element.querySelector(".CartDrawer").parentNode;
      const currentScrollPosition =
        this.element.querySelector("#main-cartItems").scrollTop;

      cartNodeParent.replaceChild(
        tempElement.querySelector(".CartDrawer"),
        this.element.querySelector(".CartDrawer")
      );
      this.element.querySelector("#main-cartItems").scrollTop =
        currentScrollPosition;

    }
    setTimeout(() => {
      if (this.options["showRecommendations"] && !quantityChange) {
        this.loadRecommendations();
      }
      var focus = _this.element.querySelector("[data-scrollable]");
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
      _this.sidebarDrawer.maxHeight();
    }, 200);
  }

  loadRecommendations() {
    const _this = this;
    // Determine the URL to fetch recommendations based on the product ID option.
    const productId = this.options.productId;
    const url = productId
      ? `${window.routes.localeRootUrl}/recommendations/products?section_id=helper-recommendations&product_id=${productId}&limit=10`
      : "?section_id=helper-recommendations";

    // Fetch the recommendations and parse the HTML content.
    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (content) {
        const container = document.createElement("div");
        container.innerHTML = content;

        // Insert the recommendations HTML into the recommendations container.
       const upsellContainer = container.querySelector(".cartUpsell");
       const recommendationsContainer = _this.element.querySelector(".CartMobileRecommendations");
       recommendationsContainer.innerHTML = upsellContainer.innerHTML;


        // Initialize the Swiper instance with the recommendations container and options.
        const swiper = new Swiper(recommendationsContainer.querySelector(".swiperUpsell"), {

          slidesPerView: 2,
          spaceBetween: 32,
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0,

          loop: false,
          pagination: {
            el: ".sidecart_pagination",
            type: "bullets",

            clickable: true
          },
          breakpoints: {
            1025: {
              slidesPerView: 2,
              spaceBetween: 32,
              slidesOffsetAfter: 0,
              slidesOffsetBefore: 0,
              navigation: {
                nextEl: ".swiperNextCart",
                prevEl: ".swiperPrevCart"

              },
            },
          },
        });


        // Dispatch a custom event to toggle favorites state.
        _this.element.dispatchEvent(new CustomEvent("favorites:toggle", { bubbles: true }));

        // Show the recommendations section and run the Revolution animation if enabled.
        const recommendationsSection = _this.element.querySelector(".cartRecommendations");
        recommendationsSection.style.display = "block";
 

         const cartDrawerRecommendation = _this.element.querySelector("#cartDrawer--recommendation");

        let cartDrawerSlidesRecommendation = _this.element.querySelectorAll('#cartDrawer--recommendation .cartSlideItem');

        if( cartDrawerSlidesRecommendation.length === 0 ){

          cartDrawerRecommendation.style.display = 'none';
        }
      })
      .catch(function (error) {
        // Handle the error gracefully by logging it or displaying an error message to the user.
        // For this implementation, we will not output errors to the console.
        // Instead, we can display an error message in the UI or send the error to a monitoring service.
      });
}
}
customElements.define("cart-drawer", CartDrawer);


class FeaturedCollectionSection extends HTMLElement {
  constructor() {
    super();
    var _this = this;
    this.element = this;
    this.domDelegate = new Delegate(this.element);
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);

    this.bindEvents();

    new AddToCart(this.element);
  }

  bindEvents() {
    this.isPageLoaded =
      document.readyState === "complete" ||
      document.readyState === "loaded" ||
      document.readyState === "interactive";
    if (!this.isPageLoaded) {
      window.addEventListener("load", this.onPageLoaded.bind(this));
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.carousel = new RevolutionSwiper(this.carouselElement);
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "-100px 0px 200px 0px",
    }).observe(this);
  }
}
customElements.define("featured-collection", FeaturedCollectionSection);

class SliderTextSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);


  }
}
customElements.define("slider-text", SliderTextSection);

class Banner extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.carouselElement = this.element.querySelector("[data-swiper-settings]");
    this.delegateBody = new Delegate(document.body);
    this.nextSectionButton = this.element.querySelector(".HeroBanner--NextSectionButton button");
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.delegateElement = new Delegate(this.element);
    if (this.options["numberOfSlides"] > 1) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
      this.onImagesReady = this.createObserver.bind(this);
      this.element.addEventListener("swiper:slide-changed", this.onImagesReady);
      this.createObserver();
    } else {
      this.createObserver();
    }

    if (this.nextSectionButton) {
      this.nextSectionButton.addEventListener("click", this.scrollToNextSection.bind(this));
    }
  }

  scrollToNextSection() {
    const elementRect = this.element.getBoundingClientRect();
    const scrollToY = window.scrollY + elementRect.bottom;

    window.scrollTo({
      top: scrollToY,
      behavior: "smooth"
    });
  }

  createObserver() {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.5,
    });

    const target = this.element;
    this.observer.observe(target);
  }

  handleIntersect(entries) {
    var _this = this;
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (_this.options["numberOfSlides"] > 1) {
          _this.changeImageQuality();
        } else {
          _this.changeImageQuality(true);
        }
        _this.observer.unobserve(_this);
      }
    });
  }
  changeImageQuality(singleItem) {
    // Get the current breakpoint.
    const breakpoint = new Responsive().getCurrentBreakpoint();

    let imageContainers;
    // Determine which element(s) to search for based on the singleItem parameter.
    if (singleItem) {
      imageContainers = Array.from(this.element.querySelectorAll('.Banner__ImageContainer--Swap'));
    } else {
      const currentIndex = this.carousel.swiperElement.activeIndex;
      const cellElement = this.carousel.swiperElement.slides[currentIndex];
      imageContainers = Array.from(cellElement.querySelectorAll('.Banner__ImageContainer--Swap'));
    }

    // If no image containers are found, return.
    if (imageContainers.length === 0) {
      return;
    }

    // Determine which image to reveal based on the current breakpoint.
    let imageToReveal;
    if (breakpoint === 'pocket' || breakpoint === 'phone' || breakpoint === 'tablet') {
      imageToReveal = imageContainers[0].querySelector('.Banner__Image');
    } else {
      if (imageContainers.length == 2) {
        imageToReveal = imageContainers[1].querySelector('.Banner__Image');
      } else {
        imageToReveal = imageContainers[0].querySelector('.Banner__Image');
      }

    }

    // If the image to reveal is not found or has already been loaded, return.
    if (!imageToReveal || imageToReveal.dataset.loadedImage === 'true') {
      return;
    }
    // Replace the image URL with a higher quality version.
   
  }
}
customElements.define("banner-hero", Banner);



class Header extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.getAttribute('data-settings'));

    var selectBoxes = this.element.querySelectorAll('.RevolutionSelectbox');
    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }

    if (this.options.sticky) {
      this.toggleSticky();
    }

    this.showActiveCollections();
    this.toggleColor();
    this.bindEvents();

  }

  showActiveCollections() {
    this.hideOtherElements();

    this.delegateElement.on(
      'click',
      "[data-action='toggle-tab']",
      this.toggleTab.bind(this),
      true
    );
  }

  hideOtherElements() {
    const activeDesktopMenuTab = this.element.querySelectorAll(
      '.desktopMenu--tabsContainer .tab-button.desktop.active'
    );

    const allCollections = this.element.querySelectorAll(
      '.desktopMenu--CollectionItemsWrapper'
    );
    allCollections.forEach((item) => {
      const allCollectionItem = item.querySelectorAll(
        '.desktopMenu--collectionLists'
      );
      allCollectionItem.forEach((collection) => {
        collection.style.display = 'none';
        activeDesktopMenuTab.forEach((activeTab) => {
          if (
            collection.getAttribute('data-tab') ===
            activeTab.getAttribute('data-tab')
          ) {
            collection.style.display = 'block';
          }
        });
      });
    });
  }

  toggleTab(event) {
    const openDropdown = this.element.querySelector('.header--Links[aria-expanded="true"] .desktopMenu--Dropdown');
  

    const allTabsFromOpenDropdown = openDropdown.querySelectorAll('.tab-button.desktop');
    

     allTabsFromOpenDropdown.forEach(item => {
        item.classList.remove('active');
        item.classList.remove('underline');
     });

     event.target.classList.add('active');
  
   


    this.hideOtherElements();
  }

  menuOverlapHandler() {
    var currentClientWidth = Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );

    var menuItems = this.element.querySelector('.header--MenuItems'),
      overlapping = false,
      menuWrapper = this.element.querySelector('.header--Wrapper'),
      allHeights = [],
      _this = this;
    if (menuItems) {
      var desiredHeight = _this.element.querySelectorAll('.mainLinks');
      desiredHeight.forEach((item) => {
        allHeights.push(item.offsetHeight);
      });
      var maxHeight = Math.max.apply(null, allHeights);
      var minHeight = Math.min.apply(null, allHeights);
      if (maxHeight > minHeight) {
        overlapping = true;
        if (
          window.theme.menuBreakpoint == 0 ||
          window.theme.menuBreakpoint == undefined
        ) {
          window.theme.menuBreakpoint = currentClientWidth;
        }
      }
    }
    if (currentClientWidth > window.theme.menuBreakpoint) {
      menuItems.classList.remove('mt-m');
      menuItems.classList.remove('mainMenu--Overlapping');
      menuWrapper.querySelector('.mainMenuItems').prepend(menuItems);
      window.theme.menuBreakpoint = 0;
    } else if (overlapping) {
      menuItems.classList.add('mt-m');
      menuItems.classList.add('mainMenu--Overlapping');
      menuItems.closest('.header').appendChild(menuItems);
    }
    document.documentElement.style.setProperty(
      '--header-height',
      _this.element.clientHeight + 'px'
    );

    menuItems.style.opacity = 1;
  }

  toggleSticky() {
    this.element.parentElement.classList.add('header--Sticky');
    this.element.parentElement.classList.remove('Header--Transparent');
  }

  bindEvents() {
    const _this = this;
 


    this.toggleColorListener = this.toggleColor.bind(this);

    window.addEventListener('scroll', this.toggleColorListener);
    this.delegateBody.on('menu:close', this.closeMenu.bind(this), true);

    const mainLinks = this.element.querySelectorAll('.mainLinks');
   

setTimeout(() => {
  mainLinks.forEach(item => {
      if(item.getAttribute("aria-hasMenu='true'")){
       item.setAttribute("aria-singleMenu", "");
      }else{
          
      }
    });
}, 250);
    

    this.delegateElement.on(
      'mouseenter',
      "[aria-hasMenu='true']",
      this.openMenu.bind(this),
      true
    );

    this.delegateElement.on(
      'focusin',
      "[aria-hasMenu='true']",
      this.openMenu.bind(this),
      true
    );

    this.delegateElement.on(
      'mouseleave',
      '[aria-submenu]',
      this.closeMenu.bind(this),
      true
    );

    this.delegateElement.on(
      'mouseenter',
      '[aria-singlemenu]',
      this.closeMenu.bind(this),
      true
    );

    this.delegateElement.on(
      'focusin',
      '[aria-singleMenu], .mainLinks',
      this.closeMenu.bind(this),
      true
    );
  }

  updateMenuPosition() {
    document.documentElement.style.setProperty(
      '--submenu-position',
      `${document.querySelector('#header').offsetHeight}px`
    );
  }

  openMenu(event, target) {
    // Dispatch a custom event to indicate that the menu is being opened.
    this.element.dispatchEvent(new CustomEvent('menu:open', { bubbles: true }));

    // If the event is a mouseenter event and the target is not the same as the event target, return.
    if (event.type === 'mouseenter' && target !== event.target) {
      return;
    }

    // Update the position of the menu and change the ARIA expanded attribute.
    this.updateMenuPosition(target);
    this.element.classList.remove('Header--Transparent');
    target.setAttribute('aria-expanded', 'true');

    // Close any siblings of the target element.
    const siblings = Array.from(target.parentElement.children).filter(
      (child) =>
        child !== target && child.getAttribute('aria-expanded') === 'true'
    );
    siblings.forEach((item) => item.setAttribute('aria-expanded', 'false'));

    // Disable body scroll on the scrollable element inside the menu.
    const scrollableElement = this.element.querySelector('[data-scrollable]');
    if (!scrollableElement) {
      return;
    }
    bodyScrollLock.disableBodyScroll(scrollableElement, bodyScrollLockOptions);
  }

  closeMenu(event, target) {
    if (event.type === 'mouseleave' && target !== event.target) {
      return;
    }
    if (this.options['transparent']) {
      this.element.classList.add('Header--Transparent');
    }

    const allOpen = this.element.querySelectorAll('[aria-expanded="true"]');
    allOpen.forEach(function (item) {
      item.setAttribute('aria-expanded', 'false');
    });
    this.toggleColor();
    bodyScrollLock.clearAllBodyScrollLocks();
  }

  toggleColor() {
    if (window.pageYOffset > 25) {
      this.element.classList.add('Header--Scrolled');
    } else {
      this.element.classList.remove('Header--Scrolled');
    }
    if (this.options.transparent) {
      if (window.pageYOffset > 25 && this.options.sticky) {
        this.element.classList.remove('Header--Transparent');
      } else {
        this.element.classList.add('Header--Transparent');
      }
    }
  }
}
customElements.define("header-component", Header);

class Transition {
  constructor() {
    this.pageOverlay = document.querySelector(".pageTransition");

    if (!this.isPageLoaded) {
      document.addEventListener(
        "DOMContentLoaded",
        this.onPageLoaded.bind(this)
      );
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    this.isPageLoaded = true;
    if (this.pageOverlay && window.theme.showPageTransition) {
      this.pageOverlay.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 100,
        fill: "forwards",
        easing: "ease-in-out",
        iterations: 1,
      });
    }
  }

  onPageUnload(event, target) {
    if (
      event.defaultPrevented ||
      event.ctrlKey ||
      event.metaKey ||
      !window.theme.showPageTransition ||
      !this.pageOverlay
    ) {
      return;
    }

    event.preventDefault(); // Prevent the click to happen

    if (this.pageOverlay) {
      var timeline = new TimelineLite({
        onComplete: function onComplete() {
          window.location.href = target.href;
        },
      });

      timeline.fromTo(
        this.pageOverlay,
        0.25,
        { autoAlpha: 0, ease: Linear.easeNone },
        { autoAlpha: 1, ease: Linear.easeNone }
      );
    }
  }
}
var trans = new Transition();

class VideoComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.trueObserver = false;
    this.hasUserInteracted = false;
    this.checkLoaded();

      if (!this.options["muted"]) {
      this.addUserInteractionListeners();
      this.createUnmuteButton();
    }

    if (this.options["using_fade"] == "fade") {
      if (
        this.element.dataset.position == 0 ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-active") ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-duplicate-active")
      ) {

        this.bindEvents();
      }
    } else {
      this.createObserver();
    }

    if(this.options["muted"] == false && this.options["controls"] == false){
      this.userInputListeners = new Map();
      this.userInputListeners.set("click", this.handleUserInteraction.bind(this));
      this.userInputListeners.set("touchstart", this.handleUserInteraction.bind(this));

      document.addEventListener("click", this.userInputListeners.get("click"));
      document.addEventListener("touchstart", this.userInputListeners.get("touchstart"));

      this.unmuteButton = document.createElement("button");
      this.unmuteButton.textContent = "Unmute";
      this.unmuteButton.id = "myButton";
      this.element.appendChild(this.unmuteButton);
      this.unmuteButton.classList.add("videoJs--unmuteButton", "u-p3");
    }
  }

  createUnmuteButton() {
    this.unmuteButton = document.createElement("button");
    this.unmuteButton.textContent = "Unmute";
    this.unmuteButton.id = "myButton";
    this.element.appendChild(this.unmuteButton);
    this.unmuteButton.classList.add("videoJs--unmuteButton", "u-p3");
    this.unmuteButton.style.opacity = 0; // Initially hide the button
    this.unmuteButton.addEventListener("click", this.handleUserInteraction.bind(this));
  }

  addUserInteractionListeners() {
    this.userInputListeners = new Map();
    this.userInputListeners.set("click", this.handleUserInteraction.bind(this));
    this.userInputListeners.set("touchstart", this.handleUserInteraction.bind(this));
    document.addEventListener("click", this.userInputListeners.get("click"));
    document.addEventListener("touchstart", this.userInputListeners.get("touchstart"));
  }

  bindEvents() {
    window.removeEventListener("swiper:slide-changed", this.onSlideChangeListener);
    this.onSlideChangeListener = this.onSlideChange.bind(this);
    window.addEventListener("swiper:slide-changed", this.onSlideChangeListener);
  }


  checkLoaded() {
    var _this = this;
    if (typeof videojs !== "undefined") {
      this.videoPlayerInitialization();
    } else {
      loadScript(window.theme.videoScript);
      setTimeout(function () {
        _this.checkLoaded();
      }, 100);
    }
  }

  onSlideChange(event) {
    console.log(event);

    this.elementPosition = parseInt(this.element.getAttribute("data-position"));
      if (event.detail.currentIndex == this.elementPosition) {
        if (!this.element.getAttribute("loaded")) {
          var node = document.createElement("div");
          node.appendChild(
            this.element
              .querySelector("template")
              .content.firstElementChild.cloneNode(true)
          );
          this.element.appendChild(node.firstElementChild).focus();
          this.element.setAttribute("loaded", true);
          if (!this.videoPlayer) {
            this.checkLoaded();
            console.log('3');
          } else {
            if (this.options['viewport']) {
              console.log('1');
              this.videoPlayer.play();
              this.createObserver();
            }
          }
        } else {
          if (!this.videoPlayer) {
            this.checkLoaded();
            console.log('4');
          } else {
            console.log('2');
            if (this.options['viewport']) {
              this.videoPlayer.play();
              this.createObserver();
            }
          }
        }
      } else if (this.videoPlayer && this.videoPlayer.el_.classList.contains('vjs-playing')) {
        this.videoPlayer.pause();
      }

  }

  videoPlayerInitialization() {
    if (!this.element.getAttribute("loaded")) {
      const node = document.createElement("div");
      node.appendChild(
        this.element.querySelector("template").content.firstElementChild.cloneNode(true)
      );
      this.element.appendChild(node.firstElementChild).focus();
      this.element.setAttribute("loaded", true);
    }

    const responsive = new Responsive();
    const breakpoint = responsive.getCurrentBreakpoint();
    const isMobile = breakpoint === "phone" || breakpoint === "tablet";

    let aspect_ratio = "";
    let src = "";
    let host = "html5";


    if (isMobile) {
      aspect_ratio = this.options["aspect_mob"] || "9:16";



      if (this.options["videoType"] == 'video_inside_media') {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach(obj => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        const aspectRatioHeight = Math.floor(100 / this.options["videod"]["aspect_ratio"]);
        if (!this.options['videoRatio']) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        src = topQuality['url'] + "#t=0.001";
      } else if(this.options["videoType"] == 'video_inside_media_external') {
        const aspectRatioHeight = Math.floor(100 / this.options["videom"]["aspect_ratio"]);
        if (!this.options['videoRatio']) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        host = this.options["videom"]["host"];
        if (host == 'youtube') {
          src = "https://www.youtube.com/watch?v=" + this.options["videom"]["external_id"];
        } else {
          src = this.options["videom"]["external_id"];
        }

      } else {

        if (this.options["videom"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videom"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videom"];
      }
    } else {
      aspect_ratio = this.options["aspect_desk"] || "16:9";

      if (this.options["videoType"] == 'video_inside_media') {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach(obj => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        src = topQuality['url'] + "#t=0.001";
        const aspectRatioHeight = Math.floor(100 / this.options["videod"]["aspect_ratio"]);
        if (!this.options['videoRatio']) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
      } else if(this.options['videoType'] == 'video_inside_media_external') {
        host = this.options["videod"]["host"];
        const aspectRatioHeight = Math.floor(100 / this.options["videod"]["aspect_ratio"]);
        if (!this.options['videoRatio']) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        if (host == 'youtube') {
          src = "https://www.youtube.com/watch?v=" + this.options["videod"]["external_id"];
        } else {
          src = this.options["videod"]["external_id"];
        }
      } else {
        if (this.options["videod"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videod"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videod"];

      }
    }
    if (!src){
      src = "https://www.youtube.com/watch?v=_9VUPq3SxOc";
      host = "youtube";
    }
    const type = host === "youtube" ? "video/youtube" : host === "vimeo" ? "video/vimeo" : "video/mp4";



    aspect_ratio = aspect_ratio.replace('/',':');
    const payload = {
      aspectRatio: aspect_ratio,
      autoplay: false,
      muted: this.options["muted"],
      loop: this.options["loop"],
      controls: this.options["controls"],
      poster: false,
      preload: "metadata",
      playsinline: true,
      responsive: true,
      techOrder: [host],
      disablePictureInPicture: true,
      controlBar: {
        children: [
          "playToggle",
          "progressControl",
          "currentTimeDisplay",
          "timeDivider",
          "durationDisplay",
          "CustomControlSpacer",
          "VolumePanel",
          "fullscreenToggle"
        ]
      },

      sources: [
        {
          type: type,
          src: src,
        },
      ],
    };

    const videoplayerID = this.element.querySelector("video");
    this.videoPlayer = videojs(videoplayerID, payload);

    const _this = this;
    this.videoPlayer.on("ready", function () {
      _this.element.querySelector(".videoHolder").style.display = "block";

      if (_this.trueObserver == false && _this.options['viewport']) {
        _this.createObserver();
      }
    });
    if(this.options["controls"]){
      this.videoPlayer.on("touchstart", function () {
        if (event.target.closest('.vjs-control-bar')) {
          return;
        }
        if (_this.videoPlayer.paused()) {
          _this.videoPlayer.play();
        } else {
          _this.videoPlayer.pause();
        }
      });
    }

  }



  createObserver() {
    const observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.2,
      rootMargin: "200px 0px 200px 0px"
    });

    observer.observe(this.element);
    this.trueObserver = true;
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {

      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (!this.videoPlayer) {
          const intervalId = setInterval(() => {
            if (this.options["viewport"] && this.videoPlayer) {
              if(this.options['muted']) this.videoPlayer.muted('true');
              else this.videoPlayer.muted(true);
        
              const checkIfPlaying = () => {
                if (!this.videoPlayer.el_.classList.contains('vjs-playing')) {
  
                  this.videoPlayer.play();
                  setTimeout(checkIfPlaying, 100); // Wait 100 milliseconds and check again
                }
              };
              const target = entry.target.closest('.Banner__Cell');
              if(target && target.classList.contains('.swiper-slide-visible')){
                checkIfPlaying();                
              } else if(!target) {
                checkIfPlaying();
              }
            
              
         

              if(this.videoPlayer) {
                clearInterval(intervalId);
                setTimeout(() => {
                  if(!this.hasUserInteracted && this.unmuteButton) this.unmuteButton.style.opacity = 1;
                }, 5000)
              }
            }
          }, 100)
          return;
        }

        if(!this.options['muted']){
          this.videoPlayer.muted(false);
        }
          if (this.options["viewport"] && this.videoPlayer) {
            if(this.options['muted']) this.videoPlayer.muted('true');
            else if(this.hasUserInteracted) this.videoPlayer.muted(false);

            const checkIfPlaying = () => {
              if (!this.videoPlayer.el_.classList.contains('vjs-playing')) {
                this.videoPlayer.play();
                setTimeout(checkIfPlaying, 100); // Wait 100 milliseconds and check again
              }
            };

            checkIfPlaying();
          }
      } else if (
        entry.intersectionRatio === 0 ||
        entry.isIntersecting == false
      ) {
        if (this.videoPlayer && this.videoPlayer.el_.classList.contains('vjs-playing')) {
          if (this.videoPlayer.el_.classList.contains('vjs-fullscreen')) return;
          this.videoPlayer.pause();
        }
      }
    });
  }

  handleUserInteraction() {
    if (!this.hasUserInteracted) {
      this.videoPlayer.muted(false);
      this.hasUserInteracted = true;
      this.unmuteButton.style.opacity = '0';

      document.removeEventListener("click", this.userInputListeners.get("click"));
      document.removeEventListener("touchstart", this.userInputListeners.get("touchstart"));
    }
  }
}
customElements.define("video-component", VideoComponent);

class FooterComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    let responsive = new Responsive();
    let breakpoint = responsive.getCurrentBreakpoint();

  }
}
customElements.define("footer-component", FooterComponent);



class ProductElement extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.domDelegate = new Delegate(this.element);
    this.carouselElement = this.element.querySelector(".mainSwiper");
    this.carouselElementThumbs = this.element.querySelector(
      ".ProductSlider--Thumbnails"
    );

    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );


    if(this.options['slides_number'] > 1){
      if(this.options['show_thumbnails']){
        this.carousel = new RevolutionSwiper(
          this.carouselElement,
          this.carouselElementThumbs
        );

      }else{
        this.carousel = new RevolutionSwiper(
          this.carouselElement
        );
      }
    }

    this.changeImageQuality();
    this.valuesWrap = this.element.querySelectorAll(
      ".ProductOption--ValusWrapper"
    );
    var localPickup = this.element.querySelector("#LocalPickup");
    if (localPickup) {
      new Drawer(this.querySelector("#LocalPickup"));
    }
    new AddToCart(this.element);



    if (this.options["enable_zoom"]) {
      new RevolutionImageZoom(this.element, this.carousel);
    }

    var selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");

    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }


    if(this.options['variant_image_id'] && this.options['show_variant_image_on_load']){
      this.updateImage();
    }

  if(this.options['slides_number'] > 1 && this.options['show_thumbnails']){
       let newHeight = this.element.querySelector('.ProductSliderCell.swiper-slide-active img').offsetHeight;

       setTimeout(() => {
        this.updateHeightThumbnails();
       }, 100);


    }
    this.bindEvents();
  }

  bindEvents() {
    this.domDelegate.on("variant:changed", this.updateImage.bind(this));
     if(this.options['slides_number'] > 1 && this.options['show_thumbnails']){
      window.addEventListener("resize", this.updateHeightThumbnails.bind(this));
    }
  }

updateHeightThumbnails(){
  let newHeight = this.element.querySelector('.ProductSliderCell.swiper-slide-active img').offsetHeight;

  this.element.querySelector('.mainProduct--thumbnailsWrapper').style.height = `${newHeight}px`;
}
  updateImage(event) {
    if (event){
      var imageID = event.detail.new_image;
    } else {
      var imageID = this.options['variant_image_id'];
    }

    var selector = "#Image--" + imageID;
    var imageEl = this.element
      .querySelector(selector);


      if(imageEl){
        this.carousel.selectCell(parseInt(imageEl.getAttribute("data-position")));
      }

  }

  changeImageQuality() {
    var imageToReveal = null;
    imageToReveal = this.element.querySelector(
      ".ProductSlider--ImageFirst"
    );
    if (imageToReveal !== null) {
      const replaceUrl = imageToReveal
        .getAttribute("data-src")
        .replace("{width}x", "2600x");
      imageToReveal.src = replaceUrl;
    }
  }
}
customElements.define("product-component", ProductElement);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.type = this.element.getAttribute("data-type");
    this.productID = this.element.getAttribute("data-product-id");
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.bindEvents();
  }

  bindEvents(){
    this.delegateBody.on("quantity:changed", this.onQuantityChange.bind(this));

    var selectboxes = this.element.querySelectorAll("select, input");
    selectboxes.forEach((item) => {
      item.addEventListener("change", this.onVariantChange.bind(this));
    });
  }


  onQuantityChange(){
    this.updateOptions();
    this.updateMasterId();
   /*  this.toggleAddButton(); */
  }


  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
  /*   this.toggleAddButton(); */
    this.updatePickupAvailability();

    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select, input:checked"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      this.options;
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const newMedia = this.currentVariant.featured_media.id;
    if (!newMedia) return;
    this.element.dispatchEvent(
      new CustomEvent("variant:changed", {
        bubbles: true,
        detail: { new_image: newMedia },
      })
    );
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.productID}, #product-form-installment`
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = ".mainProduct--regularPricevalue";
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destinations = document.querySelectorAll(id);
        const source = html.querySelector(id);


        if (source && destinations) {
        destinations.forEach((destination) => {
          destination.innerHTML = source.innerHTML;
        });
      }

        const quantityButton = document.querySelector('.QuantityHandler');
        if(quantityButton){
          const source = html.querySelector('.QuantityHandler');
          if (source && quantityButton) quantityButton.innerHTML = source.innerHTML;
        }
       /*  this.toggleAddButton(); */
      });
  }



  toggleAddButton() {
    let quantity = "";
    const addButton = document.querySelector(".ProductPage--ATC"),
          addButtonInner = addButton.querySelector(".SelfAlign"),
          quantityEl = document.querySelector('.QuantitySelector__ProductQuantity');
          if(quantityEl){
                quantity = quantityEl.value;
          }
    if (window.variantInfo.show_icon) {
      var buySvg =
        '<svg class="Svg Svg--shopping_cart mr-m" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M25.31 5.19547C25.1687 5.02127 24.9568 4.91946 24.7325 4.91797H9.11751L9.60501 6.41797H23.75L21.7475 15.418H10.4975L7.07001 4.56547C6.99476 4.33174 6.80986 4.14965 6.57501 4.07797L3.50001 3.13297C3.24278 3.05393 2.96292 3.11812 2.76584 3.30137C2.56877 3.48461 2.48443 3.75907 2.54459 4.02137C2.60476 4.28366 2.80028 4.49393 3.05751 4.57297L5.75001 5.39797L9.19251 16.273L7.96251 17.278L7.86501 17.3755C7.2374 18.0987 7.21221 19.1659 7.80501 19.918C8.21952 20.4221 8.84817 20.7002 9.50001 20.668H22.0175C22.4317 20.668 22.7675 20.3322 22.7675 19.918C22.7675 19.5038 22.4317 19.168 22.0175 19.168H9.38001C9.20436 19.162 9.0446 19.0646 8.95873 18.9113C8.87286 18.7579 8.87334 18.5709 8.96001 18.418L10.7675 16.918H22.3475C22.705 16.9267 23.0189 16.6818 23.0975 16.333L25.475 5.83297C25.5212 5.6064 25.4603 5.37117 25.31 5.19547ZM20.75 25.168C21.682 25.168 22.4375 24.4125 22.4375 23.4805C22.4375 22.5485 21.682 21.793 20.75 21.793C19.818 21.793 19.0625 22.5485 19.0625 23.4805C19.0625 24.4125 19.818 25.168 20.75 25.168ZM12.185 23.4805C12.185 24.4125 11.4295 25.168 10.4975 25.168C9.56553 25.168 8.81001 24.4125 8.81001 23.4805C8.81001 22.5485 9.56553 21.793 10.4975 21.793C11.4295 21.793 12.185 22.5485 12.185 23.4805Z" fill="#121212"></path></svg>';
    } else {
      var buySvg = "";
    }

    if (!addButton) return;
    if (!quantity){quantity = 1;}

    if (this.currentVariant.available == false) {
      addButton.setAttribute("disabled", "disabled");
      addButton.classList.add("ProductCard--Sold__Out");
      addButtonInner.classList.add('u-p3');
      addButtonInner.innerHTML = buySvg + window.variantStrings.soldOut;
    } else {
      addButton.removeAttribute("disabled");
      addButton.classList.remove("ProductCard--Sold__Out");
      if (window.variantInfo.show_price) {
        var priceElement =
          "<span class='u-p3 ml-s'>" +
          Shopify.formatMoney(
            this.currentVariant.price * quantity,
            window.theme.moneyFormat
          );
        +"</span>";
      } else {
        var priceElement = "";
      }

      addButtonInner.innerHTML =
        buySvg + window.variantStrings.addToCart + priceElement;
    }
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define("variant-selects", VariantSelects);

class BlogSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.blogWrapper = this.element.querySelector("#BlogArticleWrapper");
    this.blogElement = this.element.querySelectorAll(".BlogArticle");



    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    if (this.options.layout == "masonary") {
      window.addEventListener('resize', this.setupGetInspredGrid.bind(this));
     document.addEventListener('DOMContentLoaded', this.setupGetInspredGrid.bind(this));
    }
  }

  setupGetInspredGrid() {
    const el = this.blogWrapper;
    if (el.lengtth == 0) {
      return;
    }

    var currentClientWidth = Math.max(
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );


    const items = this.blogElement;
    const lastItem = items[items.length - 1];
    if (items.length == 0) {
      return;
    }

    const itemWidth = parseFloat(window.getComputedStyle(lastItem).width);

    let maxItemHeight = lastItem.offsetHeight;
    const numberOfCols = Math.floor(currentClientWidth / itemWidth);

    let isSmall = false;
    let rowTemp = 0;
    let maxHeight = 0;
    items.forEach((item, i) => {
      let rowHeiht = 0;


      const col = i % numberOfCols;
      const row = Math.floor(i / numberOfCols);

      /*calculate height of row, global max item height */
      if (row > 0) {
        for (let i = 1; i <= row; i++) {
          const preParalelIndex = col + (i - 1) * numberOfCols;
          const paralelEl = items[preParalelIndex];
          rowHeiht = rowHeiht + paralelEl.offsetHeight;

          maxItemHeight =
            maxItemHeight < paralelEl.offsetHeight
              ? paralelEl.offsetHeight
              : maxItemHeight;
        }

        maxHeight = maxHeight < rowHeiht ? rowHeiht : maxHeight;
      }

      /* initialize is small flag for that row */
      if (row !== rowTemp) {
        rowTemp = row;

        isSmall = row % 2 != 0;
      }

      const left = col * itemWidth;

      const top = rowHeiht.toFixed(2);

      if (top !== "NaN") {
        const isHidden = false; //row > numberOfRows-2 && col%2 == 0; //hidden last two blog posts, overflow problem

        if (!isHidden) {
          const padding = isSmall
            ? `${90 + Math.random() * 20}%`
            : `${110 + Math.random() * 40}%`;

          item.querySelector(".BlogItem--Wrapper").style.paddingTop =
            padding + "px";

          const myitem = item;
          myitem.style.cssText = "left:" + left + "px;top:" + top + "px";

          isSmall = !isSmall;
        }
      }
    });

    var elHeight = parseInt(maxHeight) + parseInt(maxItemHeight);
    el.style.cssText =
      "width:" +
      numberOfCols * itemWidth +
      "px;height:" +
      elHeight +
      "px;margin:auto";
  }
}
customElements.define("blog-section", BlogSection);

class SearchBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.searchInputElement = this.element.querySelector('[name="q"]');

    this.searchResultsElement = this.element.querySelector(".searchWrapper");
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.initialSearchLayout = this.searchResultsElement.cloneNode(true);
    this.clearSearchButton = this.element.querySelector('.searchInput--clear');
    if (window.theme.showRecentSearches) {
      this.getRecentSearches();
    }

    this.carouselElement = this.element.querySelector(".searchInitialView");
    if (this.carouselElement) {
      if (new Responsive().matchesBreakpoint("lap-and-up")) {
        this.carousel = new RevolutionSwiper(this.carouselElement);
      }
    }

    document.documentElement.style.setProperty(
      "--search-header-height",
      `${this.searchInputElement.offsetHeight + 48}px`
    );


    this.bindEvents();
  }


  bindEvents() {
    this._onInputListener = this.debounce(this.onInput.bind(this), 450);

    this.delegateElement.on(
      "click",
      '[data-action="open-search"]',
      this.openSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="clear-input"]',
      this.resetSearch.bind(this)
    );
       this.delegateElement.on(
      "click",
      '[data-action="close-search"]',
      this.closeSearch.bind(this)
    );

    this.searchInputElement.addEventListener("input", this._onInputListener);

    this.delegateElement.on(
      "click",
      '[data-action="search-string"]',
       this.onRecentSearchClick.bind(this)
    );

    this.delegateElement.on(
      "keypress",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );
    this.delegateBody.on("menu:open", this.closeSearch.bind(this));
    this.delegateBody.on("close:search", this.closeSearch.bind(this));
  }

  initCarousel() {
    if (new Responsive().matchesBreakpoint("lap-and-up")) {
      var carousel = this.searchResultsElement.querySelector(
        "[data-swiper-settings]"
      );
      if (carousel) {
        this.newCarousel = new RevolutionSwiper(carousel);
      }
    }
  }

  debounce(fn, delay) {
    var _this0 = this;

    var timer = null;

    return function () {
      for (
        var _len = arguments.length, args = Array(_len), _key = 0;
        _key < _len;
        _key++
      ) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timer);

      timer = setTimeout(function () {
        fn.apply(_this0, args);
      }, delay);
    };
  }

  openSearch(event) {
    event.preventDefault();
    const _this = this;
    // Check if search is already open, close it if true
    if (this.isOpen) {
      this.closeSearch();
      return;
    }

    const target = event.target;

    // Check if search element exists
    if (!this.element) {
      console.error('Search element not found');
      return;
    }

    // Load recommendations if product is enabled and collection is empty and searchSlide is not present

    if (
      !this.element.querySelector(".searchSlide") &&
      this.options["product"] &&
      !this.options["collection"]
    ) {
      this.loadRecommendations();
    }

    // Show search element and page overlay
    const search = target.parentElement.querySelector(".search");
    if (search) {
      search.setAttribute("aria-hidden", false);
    }
    this.pageOverlayElement.classList.add("is-visible");

    // Disable scrolling on body
    if (bodyScrollLock && this.element) {
      bodyScrollLock.disableBodyScroll(
        this.element.querySelector("[data-scrollable]"),
        bodyScrollLockOptions
      );
    }
    // Dispatch menu close event
    if (this.element) {
      this.element.dispatchEvent(
        new CustomEvent("menu:close", { bubbles: true })
      );
    }
    document.body.classList.add("scrollLock");

    // Focus on search input element after delay
    setTimeout(() => {
      if (_this.searchInputElement) {
        _this.searchInputElement.focus();
      }
    }, 200);

    // Set header and announcement bar z-index to 99
    const header = document.body.querySelector("#shopify-section-main-header");
    if (header) {
      header.style.zIndex = "99";
    }

    const announcementBar = document.body.querySelector("#shopify-section-section-announcement_bar");
    if (announcementBar) {
      announcementBar.style.zIndex = "99";
    }

    // Remove transparent class from header if options.transparent is true
    if (this.options["transparent"]) {
      setTimeout(() => {
        const header = document.body.querySelector("#header");
        if (header) {
          header.classList.remove("Header--Transparent");
        }
      }, 15);
    }



    // Set isOpen to true
    this.isOpen = true;

    // Add event listener to page overlay to close search
    if (this.pageOverlayElement) {
      this.closeListener = this.closeSearch.bind(this);
      this.pageOverlayElement.addEventListener("click", this.closeListener);
    }
  }

  closeSearch() {
    event.preventDefault();
    var _this = this;
    if (!this.isOpen) {
      return;
    }
    bodyScrollLock.enableBodyScroll(_this.element,bodyScrollLockOptions);
    document.body.querySelector("#shopify-section-main-header").style.zIndex = "5";
    document.body.querySelector("#shopify-section-section-announcement_bar").style.zIndex = "5";
    document.body.querySelectorAll(".search").forEach((item, i) => {
      item.setAttribute("aria-hidden", true);
    });
    _this.pageOverlayElement.classList.remove("is-visible");
    document.body.querySelector(
      "#shopify-section-main-header"
    ).style.backgroundColor = "transparent";
    document.body.style.position = "relative";
    document.body.style.width = "100%";
    if (_this.options["transparent"]) {
      document.body
        .querySelector("#header")
        .classList.add("Header--Transparent");
    }
    document.body.classList.remove("scrollLock");

    this.isOpen = false;
  }


  onInput(event) {
    this.allPredictiveSearchInstances = [];

    this.lastInputValue = event.target.value;

    const _this = this;
    this.searchResultsElement.style.opacity = 0;
    this.clearSearchButton.setAttribute('aria-hidden','false');
    if (event.target.getAttribute("data-value") && _this.lastInputValue === 0) {
      this.lastInputValue = event.target.getAttribute("data-value");
      const el = _this.element.querySelector("searchInput");

      el.setAttribute("value", _this.lastInputValue);
      el.value = _this.lastInputValue;
    } else {
      if (event.keyCode === 13) {
        return;
      }

      if (this.lastInputValue === "") {
        this.initialSearchLayout.style.opacity = 0;
        this.resetSearch();
        return;
      }
    }

    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(this.lastInputValue)}&resources[limit_scope]=each&section_id=search-predictive`, {

    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);

          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-search-predictive').innerHTML;
        // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
          predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
        });

      this.element.querySelector('.searchWrapper').innerHTML = resultsMarkup;
      this.initCarousel();
      this.element.querySelector('.searchWrapper').style.opacity = 1;
      if (window.theme.showRecentSearches) {
        this.recentSearches();
      }
      bodyScrollLock.disableBodyScroll(
        this.element.querySelector("[data-scrollable]"),
        bodyScrollLockOptions
      );
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }

        throw error;
      });

  }

  loadRecommendations() {
    const _this = this;
    const targetProduct = this.options["product"];
    const recommendationsUrl =
      `${window.routes.localeRootUrl}/recommendations/products?section_id=helper-search_suggested&product_id=${targetProduct}&limit=8`;

    return fetch(recommendationsUrl)
      .then(function (response) {
        return response.text().then(function (content) {
          const container = document.createElement("div");
          const contentWrapper = document.createElement("div");
          contentWrapper.innerHTML = content;
          container.innerHTML = contentWrapper.innerHTML;

          const newSwiper = _this.element.querySelector(".searchInitial--Products");
          newSwiper.innerHTML = container.querySelector(".helper--searchSuggested").innerHTML;

          _this.initCarousel();
          new AddToCart(_this.element);
        });
      })
      .catch(function (error) {
        console.error("Error loading recommendations:", error);
      });
  }


 resetSearch() {
    this.searchResultsElement.innerHTML = this.initialSearchLayout.innerHTML;

    this.searchInputElement.value = "";
    this.searchInputElement.removeAttribute("value");

    if (window.theme.showRecentSearches) { this.getRecentSearches(); }
    if (this.options["product"] && this.options["collection"] == "") { this.loadRecommendations(); }


    this.initCarousel();
    this.searchResultsElement.style.opacity = 1;
    this.clearSearchButton.setAttribute('aria-hidden','true');
  }

  recentSearches() {
    if (this.lastInputValue.length > 3) {
      var searchTerm = JSON.parse(localStorage.getItem("searchTerms") || "[]");
      if (!searchTerm.includes(this.lastInputValue)) {
        searchTerm.unshift(this.lastInputValue);
      }

      // Then, we save the search info into the local storage, by keeping only the 5 most recent
      try {
        localStorage.setItem(
          "searchTerms",
          JSON.stringify(searchTerm.slice(0, 5))
        );
      } catch (error) {}
    }
  }

  getRecentSearches() {
    let appendString = "";
    const items = JSON.parse(localStorage.getItem("searchTerms") || "[]");
    let elementToAdd = this.element.querySelector(
      ".search--recentResults"
    );
    if (items.length > 0) {
      items.forEach((id, index) => {
        appendString =
          appendString +
          "<li tabIndex='0' class='u-p3 hoverLinks' data-action='search-string' data-value='" +
          id +
          "'>" +
          id +
          "</li>";
      });

      elementToAdd.innerHTML = appendString;
    } else {
      this.querySelector('#predictiveSearch--recentSearches').style.display = "none"
      const twoColumns = this.querySelector('.predictiveSearch--twoColumns');
      if(twoColumns) twoColumns.classList.remove('predictiveSearch--twoColumns');
    }
  }

  onRecentSearchClick(event) {
  const clickedSearchWord = event.target.getAttribute("data-value");

  if (clickedSearchWord) {
    // Set the clicked word in the search input
    this.searchInputElement.value = clickedSearchWord;
    this.searchInputElement.focus();

    // Trigger a search with the clicked word (if needed)
    this.onInput({ target: this.searchInputElement });
  }
}

}
customElements.define("search-bar", SearchBar);

class ContactSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
    this.toggleButton();
  }

  bindEvents() {
    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );

  }


  toggleButton() {
    this.buttonState = true;

    var allBoxes = this.element.querySelectorAll("[data-state='required']");
    allBoxes.forEach((item, i) => {
      if (item.checked == false) {
        this.buttonState = false;
      }
    });
    if (this.buttonState == true) {
      this.element.querySelector(".Contact-Btn").removeAttribute("disabled");
    } else {
      this.element.querySelector(".Contact-Btn").setAttribute("disabled", true);
    }
  }
}

customElements.define("contact-section", ContactSection);


class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
    };
    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}

customElements.define("localization-form", LocalizationForm);

class PickupAvailability extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (!this.hasAttribute("available")) return;
    this.fetchAvailability(this.dataset.variantId);
  }

  fetchAvailability(variantId) {
    const variantSectionUrl = `${window.routes.localeRootUrl}/variants/${variantId}/?section_id=helper-pickup`;

    fetch(variantSectionUrl)
      .then((response) => response.text())
      .then((text) => {
        const sectionInnerHTML = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector(".shopify-section");
        this.renderPreview(sectionInnerHTML);
      })
      .catch((e) => {
        this.renderError();
      });
  }

  renderError() {}

  renderPreview(sectionInnerHTML) {
    this.element.innerHTML = "";

    this.element.appendChild(
      sectionInnerHTML.querySelector(".LocalPickup_--Wrapper")
    );
    if (sectionInnerHTML.querySelector("#LocalPickup")) {
      this.element.appendChild(sectionInnerHTML.querySelector("#LocalPickup"));
      new Drawer(this.element.querySelector("#LocalPickup"));
    }
  }
}

customElements.define("pickup-availability", PickupAvailability);

class CartNote extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.textarea = this.element.querySelector("textarea");
    this.button = this.element.querySelector(".CartNote--Submit");
    this.noteSucess = this.element.querySelector(".cartNote--Success");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action='update-note']",
      this.updateNote.bind(this)
    );

    this.delegateElement.on(
      "click",
      "[data-action='edit-note']",
      this.editNote.bind(this)
    );
  }
  editNote() {
    this.textarea.removeAttribute("disabled");
    this.button.innerText = window.cartStrings.enter_note;
    this.button.setAttribute("data-action", "update-note");
    this.textarea.focus();
    this.noteSucess.style.visibility = "hidden";
    this.noteSucess.style.opacity = "0";
  }

  updateNote() {
    var _this = this;
    this.value = this.textarea.value;

    fetch(window.routes.localeRootUrl + "/cart/update.js", {
      body: JSON.stringify({ note: this.value }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        if (_this.value == "") {
          return;
        }
        _this.textarea.setAttribute("disabled", "disabled");
        _this.button.innerText = window.cartStrings.note_change;
        _this.button.setAttribute("data-action", "edit-note");
        _this.noteSucess.style.visibility = "visible";
        _this.noteSucess.style.opacity = "1";
      }
    });
  }
}

customElements.define("cart-note", CartNote);

class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));

    if (this.options.edit_mode) {
      this.options.delay = 0;
      this.openNewsletter();
    } else {
      this.handleOpenOptions();
    }

     if (window.location.href.indexOf("form_type=customer#popupForm") > -1 || window.location.href.indexOf("customer_posted=true#popupForm") > -1) {
      this.options.delay = 0;
      this.openNewsletter();
    } 
  }

  handleOpenOptions() {

    const localKey = localStorage.getItem("popup-seen");

    if (this.options.show_only_once && localKey === "true") return;

    if (localKey !== "true") {
      if (this.options.scroll_amount > 0) {
        document.addEventListener("scroll", this.scrollListener);
      } else {
        this.openNewsletter();
      }
    }
  }

  scrollListener = () => {
    const body = document.body;
    const html = document.documentElement;

    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );

    const percScrolled = (window.scrollY / docHeight) * 100;

    if (percScrolled >= this.options.scroll_amount) {
      this.openNewsletter();
    }
  };

  openNewsletter() {
    document.removeEventListener("scroll", this.scrollListener);
    setTimeout(() => {
      this.element.setAttribute("aria-hidden", false);
      this.pageOverlayElement.classList.add("is-visible");
      bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);

      this.pageOverlayElement.addEventListener("click", this.closeNewsletter);

      localStorage.setItem("popup-seen", true);

      this.delegateElement.on(
        "click",
        '[data-action="close-modal"]',
        this.closeNewsletter
      );
    }, 1000 * this.options.delay);
  }

  closeNewsletter = () => {
    this.element.setAttribute("aria-hidden", true);
    this.pageOverlayElement.classList.remove("is-visible");
    bodyScrollLock.clearAllBodyScrollLocks();

    this.pageOverlayElement.removeEventListener("click", this.closeNewsletter);

    document.removeEventListener("scroll", this.scrollListener);
  };
}

customElements.define("newsletter-popup", NewsletterPopup);


class AccountHandler extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.drawer = new Drawer(this.element.querySelector('#accountDrawer'));
 this.bindEvents();

  }
  bindEvents(){

    this.delegateElement.on('click', '[data-action="toggle-tab"]', this.toggleTab.bind(this));
    this.delegateElement.on('click', '[data-action="submit-login"]', this.submitLogin.bind(this));
    this.delegateElement.on('click', '[data-action="submit-register"]', this.submitRegistration.bind(this));
    this.delegateElement.on('click', '[data-action="toggle-recovery"]', this.toggleRecovery.bind(this));
    this.delegateElement.on('click', '[data-action="submit-recovery"]', this.accountRecover.bind(this));

    this.delegateElement.on('keypress', '[data-action="submit-input-login"]', this.accountInputSubmit.bind(this));
    this.delegateElement.on('keypress', '[data-action="submit-input-reg"]', this.accountInputSubmitReg.bind(this));
     this.delegateElement.on('keypress', '[data-action="submit-input-forgot-pass"]', this.accountInputSubmitForgot.bind(this));


}

accountInputSubmitForgot(event){

   if (event.key === "Enter") {
    event.preventDefault();
   this.accountRecover(event);
  }
}

accountInputSubmitReg(event){

  if (event.key === "Enter") {
  this.submitRegistration(event);
  }
}

accountInputSubmit(event){

  if (event.key === "Enter") {
    this.submitLogin(event);
  }

}

toggleRecovery(){
  event.preventDefault();
  const id = event.target.dataset.id;

  if (id == 'recoverFlex'){
    this.element.querySelector('#recoverFlex').setAttribute('aria-visible','true');
    this.element.querySelector('#loginFlex').setAttribute('aria-visible','false');
  }
   else{
    this.element.querySelector('#recoverFlex').setAttribute('aria-visible','false');
    this.element.querySelector('#loginFlex').setAttribute('aria-visible','true');
   }
}

accountRecover(event){
    event.preventDefault();
    const _this = this;

    const registrationEndpoint = '/account/recover';

    // Create the request body with the registration data
    const requestBody = {
        'email': this.element.querySelector('#RecoverEmail').value
    };

      /* event.target.querySelector('.ButtonText').style.visibility = "hidden";
    event.target.querySelector('.itemLoader').classList.add('is-visible');  */

    // Send the AJAX request
    (async function() {
      try {
        const response = await fetch(registrationEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestBody)
        });

        const responseText = await response.text();
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = responseText;

        if (responseText.indexOf('RecoverEmail-email-error') !== -1) {

          _this.element.querySelector('#recoverFlex .accountDrawer--ErrorSpace').innerHTML = tempDiv.querySelector('#RecoverEmail-email-error').innerHTML;
        } else if(responseText.indexOf('recoverSuccess') !== -1) {


          _this.element.querySelector('#recoverFlex .accountDrawer--SuccessSpace').innerHTML = tempDiv.querySelector('#recoverSuccess').innerHTML;
        }

         event.target.querySelector('.ButtonText').style.visibility = "visible";
        event.target.querySelector('.itemLoader').classList.remove('is-visible');


      } catch (error) {
        console.log('An error occurred during the registration request:', error);
      }
    })();
}


submitRegistration(event) {
  event.preventDefault();
  const _this = this;
  const registrationEndpoint = '/account';

  // Create the request body with the registration data
  const requestBody = {
    'customer': {

      'first_name': this.element.querySelector('#register #RegisterForm-FirstName').value,
      'last_name': this.element.querySelector('#register #RegisterForm-LastName').value,

      'email': this.element.querySelector('#register #RegisterForm-email').value,

      'password': this.element.querySelector('#register #RegisterForm-password').value
    }
  };


/*   event.target.querySelector('.ButtonText').style.visibility = "hidden";
  event.target.querySelector('.itemLoader').classList.add('is-visible'); */

  // Send the AJAX request
  (async function() {
    try {
      const response = await fetch(registrationEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      });

      const responseText = await response.text();

      if (responseText.indexOf('registerErrors') !== -1) {
        console.log('Error occurred during registration');
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = responseText;

        _this.element.querySelector('#register .accountDrawer--ErrorSpace').innerHTML = tempDiv.querySelector('.registerErrors').innerHTML;
      } else {

        location.href = window.routes.account_url;
      }

   /*    event.target.querySelector('.ButtonText').style.visibility = "visible";
      event.target.querySelector('.itemLoader').classList.remove('is-visible'); */


    } catch (error) {
      console.log('An error occurred during the registration request:', error);
    }
  })();
}


submitLogin(event){
  event.preventDefault();
  const _this = this;
  const loginEndpoint = '/account/login';

  // Create the request body with the login credentials
  const requestBody = {
    'customer': {
      'email': this.element.querySelector('#customer_login #CustomerEmail').value,
      'password': this.element.querySelector('#customer_login #CustomerPassword').value
    }
  };

 /*  event.target.querySelector('.ButtonText').style.visibility = "hidden";
  event.target.querySelector('.itemLoader').classList.add('is-visible'); */

  // Send the AJAX request
  (async function () {
    try {
      const response = await fetch(loginEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      });


        const responseText = await response.text();

        if (responseText.indexOf('loginError') !== -1) {
          console.log('Incorrect email or password');
          const tempDiv = document.createElement('div');

          tempDiv.innerHTML = responseText;

          _this.element.querySelector('#login .accountDrawer--ErrorSpace').innerHTML = tempDiv.querySelector('.AlertError').innerHTML;
         /*  event.target.querySelector('.ButtonText').style.visibility = "visible";
          event.target.querySelector('.itemLoader').classList.remove('is-visible'); */
        } else {

          location.href = window.routes.account_url;

        }



    } catch (error) {
      console.log('An error occurred during the login request:', error);
    }
  })();

}

toggleTab(event) {
  const id = event.target.dataset.id;
  const allTabs = this.element.querySelectorAll('.accountDrawer--Tab[aria-expanded="true"]');
  const allContent = this.element.querySelectorAll('.accountContent');

  allTabs.forEach((tab) => {
    tab.setAttribute('aria-expanded', 'false');
  });

  event.target.setAttribute('aria-expanded', 'true');

  allContent.forEach((content) => {
    content.setAttribute('aria-visible', 'false');
  });

  const content = this.element.querySelector(`#${id}`);
  if (content) {
    content.setAttribute('aria-visible', 'true');
  }
}

}

customElements.define("account-handler", AccountHandler);


class LocalizationSelectors extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    let responsive = new Responsive();
    let breakpoint = responsive.getCurrentBreakpoint();
    var selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
    var location = this.element.getAttribute('data-settings');

    if (location == "sidebarMenu") {
      var additionalOverlay = true;
    } else {
      var additionalOverlay = false;
    }
    if (breakpoint != "pocket") {
      if (selectBoxes.length > 0) {
        selectBoxes.forEach((item, i) => {
          new RevolutionSelectbox(
            item
          );
        });
      }
    } else {
      if (selectBoxes.length > 0) {
        selectBoxes.forEach((item, i) => {
          new RevolutionSelectbox(
            item, true, additionalOverlay
          );
        });
      }
    }

  }

}
customElements.define("localization-selectors", LocalizationSelectors);

class FavoritesDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.sidebarDrawer = new Drawer(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.loader = this.element.querySelector(".loader");
    this.cartCount = document.querySelector(".FavoritesCount");

    this.toggleFavorites();
    this.bindEvents();
  }
  unbindEvents(){
        document.removeEventListener('favorite-product:open', this.onFavoritesOpenListener);

          document.removeEventListener(
          'click',
            this._addToFavoritesL
          );

  }
  bindEvents(){


 if(!document.body.classList.contains('listener')){
   this.onFavoritesOpenListener = this.onFavoritesOpen.bind(this);
   this._addToFavoritesL =  this.addToFavorites.bind(this);
this.delegateBody.on('click', '[data-action="toggle-favorites"]', this._addToFavoritesL);
     document.body.classList.add('listener');
    document.addEventListener('favorite-product:open', this.onFavoritesOpenListener);

    document.addEventListener('favorites:toggle', this.toggleFavorites.bind(this));

 }


  }


  onFavoritesOpen() {
    var _this = this;
    this.rerenderFavorites().then(function () {
      new AddToCart(_this.element);

    });
    this.sidebarDrawer.isOpen = true;
  }

  maxHeight() {
    var footer = this.element.querySelector(".CartDrawer--Footer");
    if(footer){
      var footerH = footer.offsetHeight;
    }

    this.element.querySelector(".CartItems--Wrapper").style.height =
      window.innerHeight - footerH + "px";
  }

  getSearchQueryStrings() {
    var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
        items = items.filter((id) => id !== null);

    // If we are on a product template, we make sure to remove the main product from the related product
    const bucketSize = 10.0;
    const idBuckets = [];
    items.forEach((id, index) => {
      const key = Math.floor(index / bucketSize);
      if (!idBuckets[key]) {
        idBuckets[key] = [];
      }
      idBuckets[key].push(id);
    });
    return idBuckets.reduce((acc, vall) => {
      const string = vall
        .map(function (id) {
          return "id:" + id;
        })
        .join(" OR ");

      acc.push(string);
      return acc;
    }, []);
  }

  rerenderFavorites(event, elementToAnimate) {
    this.loader.classList.add("is-visible");
    var _this32 = this;
    var queryStrings = this.getSearchQueryStrings();
    const promises = [];


    if (queryStrings.length == 0) {
      this.loader.classList.remove("is-visible");
      fetch("/?section_id=favorites-drawer").then(function (content) {
        content.text().then(function (html) {
          _this32.replaceContentFav(html);
          _this32.loader.classList.remove("is-visible");
          _this32.loadRecommendations();
        });
      });

    }
    queryStrings.forEach((string) => {
      promises.push(
        fetch("/search?view=favorites&type=product&q=" + string, {
          credentials: "same-origin",
          method: "GET",
        })
      );
    });
    promises.reduce(async (acc, val, index) => {
      const content = await val.then((response) => response.text());
      const container = this.element;
      if (!container.length) {
        _this32.replaceContentFav(content);
        _this32.loader.classList.remove("is-visible");
        _this32.maxHeight();
      } else {
        this.loader.classList.remove("is-visible");
      }
    }, Promise.resolve());

    return Promise.resolve();
  }

  replaceContentFav(html) {
    var tempElement = document.createElement("div");
    tempElement.innerHTML = html;
    var number = tempElement
      .querySelector(".countFav")
      .getAttribute("data-count");
    var cartNodeParent = this.element.querySelector(".CartDrawer");
    cartNodeParent.replaceChild(
      tempElement.querySelector("#cartData"),
      this.element.querySelector("#cartData")
    );
    this.toggleFavorites();
    this.loader.classList.remove("is-visible");
    var focus = this.element.querySelectorAll('[data-scrollable]');

    focus.forEach((item) =>{
      bodyScrollLock.disableBodyScroll(item);
    });
    return true;
  }

  toggleFavorites() {

    var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
        items = items.filter((id) => id !== null);

    var favorites = document.querySelectorAll(".ProductCard--Favorites");
    if(document.body.querySelector('.emptyHearth')){
    if(items.length > 0){
      document.body.querySelector('.emptyHearth').style.display = "none";
      document.body.querySelector('.brokenHearth').style.display = "flex";
    }else{
      document.body.querySelector('.emptyHearth').style.display = "flex";
      document.body.querySelector('.brokenHearth').style.display = "none";
    }}
    favorites.forEach(function (item) {
      var state = item.querySelector('.ProductCard--FavoritesHolder').getAttribute("state");
      var myID = item.querySelector('.ProductCard--FavoritesHolder').getAttribute("data-id");

      if (state == "not-active" && items.includes(myID)) {

        item.querySelector(".brokenHearth").style.display = "flex";
        item.querySelector(".emptyHearth").style.display = "none";
        item.querySelector('.ProductCard--FavoritesHolder').setAttribute("state", "active");
      } else if (!items.includes(myID)) {
        item.querySelector(".brokenHearth").style.display = "none";
        item.querySelector(".emptyHearth").style.display = "flex";
        item.querySelector('.ProductCard--FavoritesHolder').setAttribute("state", "not-active");
      }
    });

  }

  removeFromFavorites(productId) {
    var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
        items = items.filter((id) => id !== null);

    items = items.filter((c) => c != productId);



    try {
      localStorage.setItem(
        "productFavorites",
        JSON.stringify(items.slice(0, 50))
      );
    } catch (error) {
      console.log(error);
    }
    var _this = this;
    this.toggleFavorites();
    if (this.sidebarDrawer.isOpen == true) {
      this.rerenderFavorites().then(function () {
        new AddToCart(_this.element);
      });
    }
  }

  loadRecommendations() {

    var _this = this;

     if (this.options["productId"] == "") {
      var url = "?section_id=fav-recommendations";
    } else {
      var url =
        window.routes.localeRootUrl +
        "/recommendations/products?section_id=fav-recommendations&product_id=" +
        this.options["productId"] +
        "&limit=10";
    }

    return fetch(url).then(function (response) {
      return response.text().then(function (content) {
        var container = document.createElement("div");
        container.innerHTML = content;

        if(container){
            var z = container.querySelector(".favUpsell").innerHTML;
          var x = _this.element.querySelector(".FavoritesRecommendations");
          if(x != null){
          x.innerHTML = z;}
        }


        const swiper = new Swiper(".swiperUpsell", {
          // Default parameters
          slidesPerView: 2.185,
          spaceBetween: 16,
          navigation: false,
          loop: false,
          slidesOffsetAfter: 16,
          slidesOffsetBefore: 16,
          navigation: {
            nextEl: ".swiperNextId--favorites-drawer",
            prevEl: ".swiperPrevId--favorites-drawer"
          },
          pagination: {
            el: ".favoritePaginatio",
            type: "bullets"
          },
          breakpoints: {
            1024: {
                slidesPerView: 2.29,
                spaceBetween: 32,
                slidesOffsetAfter: 32,
                slidesOffsetBefore: 32
            },
          },
        });
        new AddToCart(x);
        _this.toggleFavorites();
        setTimeout(() => {
          _this.element.querySelector('.favEmpty').style.display = "flex";
        }, 100);

   
      });
    });
  }


  addToFavorites(event, target) {
      var _this = this;
    event.preventDefault();

    var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
        /* items = items.filter((id) => id !== null); */

    var productId = event.target.getAttribute("data-id");

    // We check if the current product already exists, and if it does not, we add it at the start
    if (!items.includes(productId) && productId != "") {
      items.unshift(productId);
    } else {
      this.removeFromFavorites(productId, false);
      //   this._favoritesNumber();
      return;
    }
    // Then, we save the current product into the local storage, by keeping only the 50 most recent
    try {
      localStorage.setItem(
        "productFavorites",
        JSON.stringify(items.slice(0, 50))
      );
      //    this._favoritesNumber();
      this.toggleFavorites();
      if (this.sidebarDrawer.isOpen == true) {
    this.rerenderFavorites().then(function () {
      new AddToCart(_this.element);
    });  }
    } catch (error) {
      // Do nothing, this may happen in Safari in incognito mode
    }
  }
}
customElements.define("favorites-drawer", FavoritesDrawer);



class FAQSection extends HTMLElement {
  constructor() {
    super();
    let foundOne = false;
    const none = document.getElementById('none');
    const noneTerms = this.querySelector('.noTerms');
    this.clearBtn = this.querySelector('.clearSeacrh');
    this.delegateElement = new Delegate(this);
    const searchInput = document.querySelector('input[rel="searchbox"]');
    this.data = document.querySelectorAll(".Faq-Section");

    this.show(false);
    const _this=this;
    searchInput.addEventListener('input', function (event) {

        // reset state
        _this.show(false)
        foundOne = false;
        _this.clearBtn.style.display = 'none';
        const input = event.target
        if (input.value) {
          _this.clearBtn.style.display = 'block';
          const toMatch = input.value.toLowerCase();

            for (let i = 0, len = _this.data.length; i < len; i++) {
                const match = _this.data[i].innerHTML.toLowerCase().includes(toMatch);
                _this.data[i].style.display = match ? 'block' : 'none';
                if (match) foundOne = true;
            }
          if (!foundOne) {
            _this.show(true);
            noneTerms.innerHTML = input.value;
          }
        } else
        _this.resetState()

    });


    this.delegateElement.on(
      "click",
      '[data-action="clear-search"]',
      this.resetState.bind(this)
    );

    document.addEventListener("DOMContentLoaded", function() {
      var links = document.querySelectorAll(".FAQNav--rowLink");

      links.forEach(function(link) {
        link.addEventListener("click", function(event) {
          links.forEach(function(link) {
            link.classList.remove("underline");
          });

          link.classList.add("underline");
        });
      });
    });


  }


   faqSearch() {
      let faqs = document.querySelectorAll('.Faq-section_content');
        let search_query = document.getElementById("searchbox").value;
        for (var i = 0; i < faqs.length; i++) {
            if(faqs[i].textContent.toLowerCase()
                    .includes(search_query.toLowerCase())) {
                faqs[i].classList.remove("is-hidden");
            } else {
                faqs[i].classList.add("is-hidden");
            }
        }
    }


     resetState() {
        for (let i = 0, len = this.data.length; i < len; i++){

          this.data[i].style.display = 'block';
        }

            this.show(false);
            this.inputValue = this.querySelector('#searchbox');

            this.inputValue.value = '';
            this.clearBtn.style.display = 'none'
    }
     show(bool) {
      none.style.display = bool ? 'block' : 'none';
    }

}
customElements.define('faq-section', FAQSection);

class CollectionShowcaseSwiper extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    const swiper = this.element.querySelector(".swiper");
    new RevolutionSwiper(swiper);
  }
}
customElements.define("collection-showcase-swiper", CollectionShowcaseSwiper);

class WordAnimation extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.splitContent();
    this.createObserver();
  }

  createObserver() {
    this.observer = new IntersectionObserver(this.wordAnime.bind(this), {
      threshold: 0.5
    });
    this.observer.observe(this.element);
  }

  wordAnime(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const keyframes = [
          { transform: 'translateY(0%)'},
        ];

        const options = {
          duration: 400,
          easing: 'linear',
          fill: 'forwards'
        };

        let delay = 0;
        let words = this.element.querySelectorAll('.animated-word');
        words.forEach(function(elem) {
          options.delay = delay;
          elem.animate(keyframes, options);
          delay += 30;
        })
        this.observer.unobserve(this.element);
      }
    })
  }

  splitContent() {
    this.element.querySelectorAll('.word-animation').forEach((elem) => {
      const words = elem.textContent.split(' ');

      elem.innerHTML = words.map(function(word) {
        let html = '<span class="usp-word-wrapper"><span class="animated-word">' + word + '</span></span>';
        return html;
      }).join('');
    });
  }
}

customElements.define("word-animation", WordAnimation);




class SliderAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(this.getAttribute("data-settings"));
    this.announcementBar = document.querySelector('.announcementBar');
    this.updateVisibleHeight();

    if(this.options.totalBlocks < 6){
      this.animateBig = false;
    }else{
      this.animateBig = true;
    }

    if (this.options.totalBlocks > 0 && this.options.enableAnimation){
      this.announcementBar1 = this.element.querySelector('#announcementBar--SwiperWrapperOne');
      this.announcementBar2 = this.element.querySelector('#announcementBar--SwiperWrapperTwo');
      this.slides = this.element.querySelectorAll(".announcementBar--Slide");
      this.fadeToggle = false;
      this.firstAnimation = true;
      this.bindEvents();
    }
  }

  bindEvents() {
    const mediaQueryBig = window.matchMedia("(min-width: 1025px)");
    const mediaQuerySmall = window.matchMedia("(max-width: 1024px)");

    this.handleBigAnimation(mediaQueryBig);
    this.handleSmallAnimation(mediaQuerySmall);

    mediaQueryBig.addEventListener("change", () => this.handleBigAnimation(mediaQueryBig));
    mediaQuerySmall.addEventListener("change", () => this.handleSmallAnimation(mediaQuerySmall));

    window.addEventListener('scroll', this.updateVisibleHeight.bind(this));
    window.addEventListener('resize', this.updateVisibleHeight.bind(this));
  
  }
  updateVisibleHeight() {
    const rect = this.announcementBar.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Calculate the visible height
    let visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

    // Ensure the visibleHeight is never negative
    visibleHeight = Math.max(visibleHeight, 0);

    // Update the height of .announcementBar with the visible height
    document.documentElement.style.setProperty('--announcement-height', `${visibleHeight}px`);
  }

   calculateVisibleHeight(element) {
        const rect = element.getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;

        const top = Math.max(rect.top, 0);
        const bottom = Math.min(rect.bottom, windowHeight);

        return Math.max(bottom - top, 0);
}

 toggleFade() {
  this.announcementBar2.style.display = "flex";

  if (this.fadeToggle) {
    this.announcementBar1.classList.remove('fade-in');
    this.announcementBar2.classList.add('fade-in');
  } else {
    this.announcementBar1.classList.add('fade-in');
    this.announcementBar2.classList.remove('fade-in');
  }

  this.fadeToggle = !this.fadeToggle;
}

fadeBig(){
  // Initially fade in the first bar
  this.announcementBar1.classList.add('fade-in');

  this.slides.forEach(slide => slide.style.visibility = "visible");

  if (this.animateBig) this.barsTimeout = setInterval(() => this.toggleFade(), this.options.interval);
}

fadeSmall() {
  const mySlides = this.slides;
  const numSlides = mySlides.length;
  let currentSlideIndex = 0;

  const animate = () => {
    if (currentSlideIndex > 0) {
      mySlides[currentSlideIndex - 1].classList.remove('fade-in');
    }

    mySlides[currentSlideIndex].classList.add('fade-in');

    this.slidesTimeout = setTimeout(() => {
      mySlides[currentSlideIndex].classList.remove('fade-in');
      currentSlideIndex = (currentSlideIndex + 1) % numSlides;
      animate();
    }, this.options.interval);
  };

  animate();
}

stopFadeBig() {
  this.announcementBar1.style.display = "none";
  this.announcementBar2.style.display = "none";

  this.announcementBar1.classList.remove('fade-in');
  this.announcementBar2.classList.remove('fade-in');

  setTimeout(() => {
    this.announcementBar1.style.display = "flex";
    this.announcementBar2.style.display = "flex";
  }, 100);

  clearTimeout(this.barsTimeout);
}

stopFadeSmall() {
  this.slides.forEach(slide => {
    if (slide.classList.contains('fade-in')) {
      slide.classList.remove('fade-in');
    }
  });
  clearTimeout(this.slidesTimeout);
}

handleBigAnimation(mql) {
  if (mql.matches) {
    if (!this.firstAnimation) {
      this.stopFadeSmall();

      this.announcementBar1.style.display = "none";
      if (this.animateBig) this.announcementBar2.style.display = "none";

      setTimeout(() => {
        this.announcementBar1.style.display = "flex";
      }, 75)

      setTimeout(() => {
        this.fadeBig();
      }, 150);
    } else {
      if (this.animateBig) this.announcementBar2.style.display = "none";
      this.fadeBig();
    }
    if (this.firstAnimation) this.firstAnimation = !this.firstAnimation;
  }
}

handleSmallAnimation(mql) {
  if (mql.matches) {
    if (!this.firstAnimation && this.animateBig) this.stopFadeBig();

    this.slides.forEach((slide, index) => {
      if (index !== 0) slide.style.display = 'none';
    });

    setTimeout(() => {
      this.fadeSmall();

      this.slides.forEach((slide, index) => {
        if (index !== 0) slide.style.display = 'flex';
      });

      if (this.firstAnimation) this.firstAnimation = !this.firstAnimation;
    }, 150);
  }
}

}
customElements.define("slider-announcement-bar", SliderAnnouncementBar);


class ProductUsp extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delElem = new Delegate(this.element);
    this.carouselElement = this.element.querySelector(".Product--UspSwiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);




    this.bindEvents();
  }

  bindEvents() {
    this.delElem.on('click', '.Product--UspItem', this.openDrawer.bind(this));
    this.delElem.on('click', '.Product--UspItemMobile', this.handleDrawerRevolution.bind(this));
    this.delElem.on('click', '[data-action="close-drawer-desk"]', this.closeDrawer.bind(this));
    this.delElem.on('click', '[data-action="download"]', this.handleDownloadClick.bind(this));
  }

  handleDrawerRevolution(){
    const id_mob =  event.target.getAttribute('data-toggle-id');
    const drawerMob = this.element.querySelector(`[id="${id_mob}"]`);
    const drawerId  = drawerMob.getAttribute('id')

    this.drawer = new Drawer(this.element.querySelector(`#${drawerId}`));

  }

  openDrawer() {
    const id_desk = event.target.getAttribute('data-toggle-id-desk');
    const drawer = this.element.querySelector(`[data-id="${id_desk}"]`);
    drawer.setAttribute('aria-hidden', 'false');

  }

  closeDrawer() {
    const drawer = event.target.closest('.Product--UspDrawer[aria-hidden="false"]');
    if (drawer) {
      drawer.setAttribute('aria-hidden', 'true');
    }
  }

  handleDownloadClick() {
    const div = event.target.closest('[data-action="download"]');
    const name = div.querySelector('.Product--UspDrawerFileName').innerHTML;
    const src = div.getAttribute('data-src');

    this.downloadFile(src, name)
  }

  downloadFile(url, filename) {
    fetch(url)
      .then(response => response.blob())
      .then(blob => {
        // Create a link element
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = filename;

        // Append the link to the body
        document.body.appendChild(link);

        // Trigger a click on the link to start the download
        link.click();

        // Remove the link from the body
        document.body.removeChild(link);
      })
      .catch(error => {
        console.error('Error downloading file:', error);
      });
  }
}
customElements.define("product-usp", ProductUsp);

class QuoteSlider extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);
    this.swiper = this.carousel.swiperElement;
    this.parseQuotes();
    this.createIntersection();
    this.swiper.on('slideChange', this.updateQuote.bind(this));
  }
  createIntersection(){
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        this.updateQuote();
      });
     });
 observer.observe(this.element);
  }
  updateQuote() {
    var keyframes = [
      { color: '#CCCCCC' },
      { color: '#000000' }
    ];
    var options = {
      duration: 200,
      easing: 'linear',
      fill: 'forwards'
    };
    var delay = 0;
    //Remove color from old slide
    if (this.currentSlide) {
      var words = this.currentSlide.querySelectorAll('.Quote--Letter')
      words.forEach(function(elem) {
        var keyframes2 = [
          { color: '#CCCCCC' }
        ];
        var options2 = {
          duration: 300,
          fill: 'forwards'
        };
        elem.animate(keyframes2, options2);
      })
    }
    //Animate new slide
    this.currentSlide = this.swiper.slides[this.swiper.activeIndex];
    var words = this.currentSlide.querySelectorAll('.Quote--Letter')
    words.forEach(function(elem) {
      options.delay = delay;
      elem.animate(keyframes, options);
      delay += 20;
    })
  }
  parseQuotes() {
    this.element.querySelectorAll('.Quote-textAnime').forEach((elem) => {
      var words = elem.textContent.split(' ');
      let fontClass = 'u-h2';
      if(elem.classList.contains('u-h3')) {
        fontClass = 'u-h3';
      }
      elem.innerHTML = words.map(function(word) {
        var letters = word.split('');
        if(word == '') {
          return;
        }
        letters = letters.map(function(l) {
          return `<span class="Quote--Letter ${fontClass}">${l}</span>`;
        }).join('');
        return '<span class="Quote--Word">' + letters + ' </span>';
      }).join('');
    })
  }
}
customElements.define("quote-slider", QuoteSlider);


class StickyButton extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(this.getAttribute("data-settings"));
    this.textElement = this.element.querySelector('.StickyButton--Text');

    window.addEventListener("scroll", this.userScrolled.bind(this));
    this.rotateText();
    this.handleFooter();
  }

  addSpace() {
    const inputString = this.textElement.innerHTML.trim();
    const spaceMul = this.options.spaceMultiplier;

    let modifiedString = inputString + '#';
    modifiedString += modifiedString + modifiedString;

    let spaceString = "&nbsp";
    for(let i = 0; i < spaceMul - 1; i++) spaceString += '&nbsp';

    modifiedString = modifiedString.replace(/#/g, spaceString);

    this.textElement.innerHTML = modifiedString;
  }

  rotateText() {
    let direction = 1;
    if (this.options.rotateClockwise) {
      direction = 1;
      this.textElement.classList.remove('rotatingCounterClockwise');
      this.textElement.classList.add('rotatingClockwise');
    }
    else {
      direction = -1;
      this.textElement.classList.remove('rotatingClockwise');
      this.textElement.classList.add('rotatingCounterClockwise');
    }

    this.addSpace();

    const spaceMul = this.options.spaceMultiplier;
    let spaceString = ' ';
    for(let i = 0; i < spaceMul - 1; i++) spaceString += ' ';

    new CircleType(this.textElement, (string) => (string + spaceString).split('')).dir(direction);  // Curves Text
  }

  changeTextColor() {
    var position = this.textElement.getBoundingClientRect();
    var x = position.left;
    var y = position.top;
    var textColor;

    const elementsAtPoint = document.elementsFromPoint(x, y);
    const elementWithBackground = elementsAtPoint.find(element =>
      Array.from(element.classList).some(className => className.includes('colorGroup'))
    );

    if (elementWithBackground) {
      const fullClassName = Array.from(elementWithBackground.classList).find(className =>
        className.startsWith('colorGroup')
      );

      if (fullClassName) {
        const colorGroup = fullClassName.replace('colorGroup--', '');

        if (colorGroup == 'primary') {
          textColor = 'black';
        } else if (colorGroup == 'secondary') {
          textColor = 'black';
        } else {
          textColor = 'white';
        }
      }
    }

    this.textElement.style.color = textColor;
  }

  userScrolled() {
    const stickyButton = document.querySelector(".StickyButton--Wrapper");

    if (window.scrollY > this.options.scrollAmount) {
      stickyButton.classList.add("fade-in");
      this.changeTextColor();
    } else {
      stickyButton.classList.remove("fade-in");
    }


    


  }

    handleFooter() {
    const stickyButton = document.querySelector(".StickyButton--Wrapper");
    const elementToObserve = document.querySelector(
      '#shopify-section-main-footer'
    );

    document.addEventListener('DOMContentLoaded', () => {
      new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
             stickyButton.classList.add("reachFooter");
          this.changeTextColor();
           
          } else {
            stickyButton.classList.remove("reachFooter");
          }
        },
        {
          rootMargin: '0px',
        }
      ).observe(elementToObserve);
    });
  }

}
customElements.define("sticky-button", StickyButton);


class MainProductStickyContent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.handleSticky();
    this.delegateElement.on('click','[data-action="click-atc"]', this.clickAtc.bind(this));
  }

  clickAtc(){
    document.querySelector('.AddToCartAjax').click();
  }

  handleSticky() {
    const stickyContent = this.element.querySelector(
      '.mainProduct--stickyContentMobile.not_desktop'
    );
    const elementToObserve = document.querySelector(
      '#shopify-section-main-footer'
    );

    document.addEventListener('DOMContentLoaded', () => {
      new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            stickyContent.setAttribute('aria-hidden', 'true');
          } else {
            stickyContent.setAttribute('aria-hidden', 'false');
          }
        },
        {
          rootMargin: '0px',
        }
      ).observe(elementToObserve);
    });
  }
}
customElements.define("main-product-sticky-content", MainProductStickyContent);

class BlogSectionCustom extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.blogWrapper = this.element.querySelector("#BlogArticleWrapperCustom");
    this.blogArticles = this.element.querySelectorAll(".BlogArticleCustom");
    this.blogItemImages = this.element.querySelectorAll(".BlogItem--Image");
    this.animTrigger = document.querySelectorAll(".reveal-overlay");
    this.toReveal = document.querySelectorAll(".reveal");

    this.bindObserver();
  }


  bindObserver() {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const targetIndex = Array.from(this.animTrigger).indexOf(entry.target);
          if (targetIndex >= 0 && targetIndex < this.toReveal.length) {
            setTimeout(() => {
              this.imageUnravel(this.toReveal[targetIndex]);
            }, 150)
          }
          observer.unobserve(entry.target);
        }
      });
    });

    this.animTrigger.forEach((item) => {
      observer.observe(item);
    });
  }

  imageUnravel(item) {
    item.classList.add("show", "float-up");
  }
}
customElements.define("blog-section-custom", BlogSectionCustom);

class DraggableMap extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delElem = new Delegate(this.element);
    this.draggableImg = this.element.querySelector('.draggable-image');
    this.copyImgPosition = this.element.querySelector('.copyImageProperties');
    this.allLocationWrappers = this.element.querySelectorAll('.ResellerMap--LocationWrapper');

    this.isDragging = false;
    this.startX = 0;
    this.startY = 0;
    this.translateX = 0;
    this.translateY = 0;
    this.moved = false;

    this.mql = window.matchMedia('(max-width: 767px)');
    this.mql.addEventListener('change', this.handleMediaQuery.bind(this));
    this.handleMediaQuery(this.mql);
  }

  removeHelpOverlay() {
    const helpOverlay = this.element.querySelector('.ResellerMap--Overlay');
    if(helpOverlay) helpOverlay.style.opacity = '0';
  }

  handleMediaQuery(mql) {
    if (mql.matches) {
      this.bindEvents();
    } else {
      this.unbindEvents();
    }
  }

  bindEvents() {
    this.delElem.on('mousedown', '.draggable-image', this.pointerDown.bind(this));
    this.delElem.on('touchstart', '.draggable-image', this.pointerDown.bind(this));
    this.delElem.on('mousemove', this.pointerMove.bind(this));
    this.delElem.on('touchmove', this.pointerMove.bind(this));
    this.delElem.on('mouseup', this.pointerUp.bind(this));
    this.delElem.on('dragstart', '.draggable-image', this.preventDefaultBehaviour.bind(this));
    this.delElem.on('touchstart', '.location__Container', this.handleLocationTouch.bind(this));
    this.delElem.on('touchstart', '.ResellerMap--Info', this.handleOverlayTouch.bind(this));
  }

  unbindEvents() {
    this.delElem.off('mousedown', '.draggable-image', this.pointerDown);
    this.delElem.off('touchstart', '.draggable-image', this.pointerDown);
    this.delElem.off('mousemove', this.pointerMove);
    this.delElem.off('touchmove', this.pointerMove);
    this.delElem.off('mouseup', this.pointerUp);
    this.delElem.off('dragstart', '.draggable-image', this.preventDefaultBehaviour);
    this.delElem.off('touchstart', '.location__Container', this.handleLocationTouch);
    this.delElem.off('touchstart', '.ResellerMap--Info', this.handleOverlayTouch);
  }

  handleOverlayTouch(e){
    e.preventDefault();

    const locationWrapper = e.target.closest('.ResellerMap--LocationWrapper');
    locationWrapper.click();
  }

  handleLocationTouch(e) {
    e.preventDefault();

    const locationWrapper = e.target.closest('.ResellerMap--LocationWrapper');
    this.allLocationWrappers.forEach(wrapper => {
      if (wrapper !== locationWrapper) {
        wrapper.classList.remove('hovered');
      }
    });
    locationWrapper.classList.toggle('hovered');
  }

  pointerDown(e) {
    e.preventDefault();
    this.isDragging = true;

    this.allLocationWrappers.forEach(wrapper => wrapper.classList.remove('hovered'));

    if (e.type === 'mousedown') {
      this.startX = e.clientX - this.draggableImg.getBoundingClientRect().left;
      this.startY = e.clientY - this.draggableImg.getBoundingClientRect().top;
    } else if (e.type === 'touchstart') {
      const touch = e.touches[0];
      this.startX = touch.clientX - this.draggableImg.getBoundingClientRect().left;
      this.startY = touch.clientY - this.draggableImg.getBoundingClientRect().top;
    }

    this.draggableImg.style.cursor = 'grabbing';
  }

  pointerMove(e) {
    e.preventDefault();
    if (!this.isDragging) return;

    if(!this.moved) {
      this.removeHelpOverlay();
      this.moved = true;
    }

    let clientX, clientY;
    if (e.type === 'mousemove') {
      clientX = e.clientX;
      clientY = e.clientY;
    } else if (e.type === 'touchmove') {
      const touch = e.touches[0];
      clientX = touch.clientX;
      clientY = touch.clientY;
    }

    const newX = clientX - this.startX - this.draggableImg.parentElement.getBoundingClientRect().left;
    const newY = clientY - this.startY - this.draggableImg.parentElement.getBoundingClientRect().top;

    this.translateX = Math.min(0, Math.max(this.draggableImg.parentElement.clientWidth - this.draggableImg.clientWidth, newX));
    this.translateY = Math.min(0, Math.max(this.draggableImg.parentElement.clientHeight - this.draggableImg.clientHeight, newY));

    this.draggableImg.style.transform = `translate(${this.translateX}px, ${this.translateY}px)`;
    this.copyImgPosition.style.transform = `translate(${this.translateX}px, ${this.translateY}px)`;
  }

  pointerUp() {
    this.isDragging = false;
    this.draggableImg.style.cursor = 'grab';
  }

  preventDefaultBehaviour(e) {
    e.preventDefault();
  }
}
customElements.define("map-draggable", DraggableMap);


class AnimationText extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
 this.bind();
  }
bind(){
      setTimeout(() => {
         // Get the original metaItem--animHolder element
      let originalAnimHolder = this.querySelector('.metaItem--animHolder');
      // Create a deep clone of the original animHolder element
      let clonedAnimHolder = originalAnimHolder.cloneNode(true);
      // Add the cloned animHolder element to the parent div
      let metaItemContent = this.querySelector('.metaItem--content');
      metaItemContent.appendChild(clonedAnimHolder);
      const animArray = this.querySelectorAll('.metaItem--animHolder');
      let i = 0;
      animArray.forEach((item) => {
        item.classList.add(`animHolder--${i}`);
        i++;
      })
       this.querySelector('.metaItem--animHolder.animHolder--1').style.opacity = 0;
      setTimeout(() => {
        this.querySelector('.metaItem--animHolder.animHolder--1').style.opacity = 1;
      }, 15000);
      }, 50);
}
}
customElements.define("animation-text", AnimationText);

class VespgulvInstagram extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    var images = new Array();
    var boxes = new Array();
    this.delegateElement = new Delegate(this.element);
    if (new Responsive().matchesBreakpoint('pocket')) {
      const swiper = this.element.querySelector(".swiper");
      new RevolutionSwiper(swiper);
    }
    var _this = this;
    var observer = new MutationObserver(function(mutations) {
       if (_this.element.querySelector('.instafeed-container')) {
        var allElements = _this.element.querySelectorAll('.instafeed-container');
        const allLinks = _this.element.querySelectorAll('#insta-feed a.follow');
        allElements.forEach((item, i) => {

          const img = item.querySelector('img');
          if(img){
                images.push(img.getAttribute('data-src'));
          }
        });

            observer.disconnect();
            _this.element.querySelectorAll('.InstagramImageWrapper').forEach((item, i) => {
              item.querySelector('img').setAttribute('src', images[i]);
              item.querySelector('img').removeAttribute('srcset');
              if(allLinks[i]){
                item.closest('a').setAttribute('href', allLinks[i].getAttribute('href'));
              }

            });
            setTimeout(document.querySelector('#insta-feed').style.display = "none", 50);
        }
    });
    observer.observe(document, {attributes: false, childList: true, characterData: false, subtree:true});
    }
    cleanSelector(selector){
      (selector.match(/(#[0-9][^\s:,]*)/g) || []).forEach(function(n){
          selector = selector.replace(n, '[id="' + n.replace("#", "") + '"]');
      });
      return selector;
    }
}
customElements.define("vespgulv-instagram", VespgulvInstagram );

class BlogSlider extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);



  }


 
}
customElements.define("blog-slider", BlogSlider);

class ErrorGrid extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delElem = new Delegate(this.element);
    this.columns = this.element.querySelectorAll(".ImageContainer-404");
    this.imageWrapper = this.element.querySelector(".ImageWrapper--404");
    this.button = this.element.querySelector(".button-404");
    this.options = JSON.parse(this.getAttribute("data-settings"));

    if(this.options)  {
      this.columnChildren = Array.from(this.columns[this.options.colsMobile - 1].children);

      this.currentIndex = 0;
      this.iterationDelay = 4000;
      this.mobileAnimRunning = false;
      this.buttonListeners = new Map();
      this.timeouts = [];

      this.mql = window.matchMedia('(max-width: 1023px)');
      this.mql.addEventListener('change', this.handleMediaQuery.bind(this));
      this.handleMediaQuery(this.mql);
    }
  }

    handleMediaQuery(mql) {
      if (mql.matches) {
        this.deleteColumns();
        if(this.button) this.unbindButtonListener();
        if(!this.mobileAnimRunning) this.mobileAnimRunning = true;
        const beginAnimTimeout = setTimeout(() => {
          this.animateImages(this.currentIndex);
        }, this.iterationDelay);

        this.timeouts.push(beginAnimTimeout);
      } else {
        if (this.mobileAnimRunning) this.stopAnimation();
        this.returnColumns();
        if(this.button) this.bindButtonListener();
      }
    }

    bindButtonListener() {
      this.buttonListeners.set("mousemove", this.hoverImageContainer.bind(this));
      this.buttonListeners.set("mouseleave", this.clearHoverState.bind(this));

      this.button.addEventListener("mousemove", this.buttonListeners.get("mousemove"));
      this.button.addEventListener("mouseleave", this.buttonListeners.get("mouseleave"));
    }

    unbindButtonListener() {
      this.button.removeEventListener("mousemove", this.buttonListeners.get("mousemove"));
      this.button.removeEventListener("mouseleave", this.buttonListeners.get("mouseleave"));
    }

    hoverImageContainer(e) {
      this.columns.forEach((column) => {
        const elementsUnderMouse = document.elementsFromPoint(e.clientX, e.clientY);

        if (elementsUnderMouse.includes(column)) {
          column.classList.add('stateHover');
        } else {
          column.classList.remove('stateHover');
        }
      });
    }

    clearHoverState() {
      this.columns.forEach((column) => {
        if(column.classList.contains('stateHover')) column.classList.remove('stateHover');
      })
    }

    deleteColumns() {
      for(let i = this.options.blockSize - 1; i >= this.options.colsMobile; i--){
        this.columns[i].style.display = 'none';
      }

      this.imageWrapper.style.gridTemplateColumns = `repeat(${this.options.colsMobile}, 1fr)`;
      this.columnChildren.forEach(child => child.style.borderRight = "none");
    }

    returnColumns() {
      this.columns.forEach(column => column.style.display = 'flex');
      this.imageWrapper.style.gridTemplateColumns = `repeat(${this.options.blockSize}, 1fr)`;
      this.columnChildren.forEach(child => child.style.borderRight = "");
    }

    animateImages(i) {
      this.mobileColImages = Array.from(this.columns).slice(0, this.options.colsMobile);
      const animationDelay = 800;

      if (i < this.mobileColImages.length) {
        this.mobileColImages[i].classList.add('showImages');

        const timeoutId = setTimeout(() => {
          this.animateImages(i + 1);
        }, animationDelay);

        this.timeouts.push(timeoutId);
      } else {
        setTimeout(() => {
          this.mobileColImages.forEach(image => image.classList.remove('showImages'));
        }, animationDelay);

        const iterationTimeoutId = setTimeout(() => {
          this.animateImages(0);
        }, this.iterationDelay);

        this.timeouts.push(iterationTimeoutId);
      }
    }

    stopAnimation(){
      if(this.mobileColImages) Array.from(this.mobileColImages).forEach(image => image.classList.remove('showImages'));
      for (const timeoutId of this.timeouts) clearTimeout(timeoutId);

      this.timeouts = [];

      if(this.mobileAnimRunning) this.mobileAnimRunning = false;
    }
}
customElements.define("error-grid", ErrorGrid);


class WordAnime2 extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.splitContent();
    this.createObserver();
  }

  createObserver() {
    this.observer = new IntersectionObserver(this.wordAnime.bind(this), {
      threshold: 0.5
    });
    this.observer.observe(this.element);
  }

  wordAnime(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const keyframes = [
          { transform: 'translateY(0%)'},
        ];

        const options = {
          duration: 400,
          easing: 'linear',
          fill: 'forwards'
        };

        let delay = 0;
        let words = this.element.querySelectorAll('.animated-word');
        words.forEach(function(elem) {
          options.delay = delay;
          elem.animate(keyframes, options);
          delay += 30;
        })
        this.observer.unobserve(this.element);
      }
    })
  }

  splitContent() {
    this.element.querySelectorAll('.word-animation').forEach((elem) => {
      const words = elem.textContent.split(' ');
      let fontClass = 'u-h2';
      if(elem.classList.contains('u-h5')) {
        fontClass = 'u-h5';
      }
      elem.innerHTML = words.map(function(word) {
        let html = `<span class="usp-word-wrapper"><span class="animated-word ${fontClass}">${word}</span></span>`;
        return html;
      }).join('');
    });
  }
}

customElements.define("word-anime2", WordAnime2);

class ImageSlideshow extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);
    this.swiper = this.carouselElement.swiper;
    this.options = JSON.parse(this.element.getAttribute("data-swiper-options"));
    this.allSlides = this.element.querySelectorAll(".swiper-slide");

    this.ignoreInit = true;
    this.shouldIgnore = false;
    this.seconds = 0;
    this.phone = false;
    this.swiperWrapperW = this.swiper.wrapperEl.clientWidth * 0.26635;

    this.swiperListeners = new Map();
    this.swiperListeners.set("slideNextTransitionStart", this.slideChangeR.bind(this));
    this.swiperListeners.set("slidePrevTransitionStart", this.slideChangeL.bind(this));
    this.swiperListeners.set("slideResetTransitionStart", this.slideReset.bind(this));
    this.swiperListeners.set("resize", this.debounce(this.onSwiperResize.bind(this), 100));

    this.mql = window.matchMedia('(min-width: 1024px)');
    this.mql.addEventListener('change', this.handleMediaQuery.bind(this));
    this.handleMediaQuery(this.mql);
    this.handleSwiperOptions();
    this.bindObserver();
  }

  checkEverySecond(){
    this.observerInterval = setInterval(() => {
      this.seconds += 1;
    }, 1000)
  }

  handleSwiperOptions() {
    if(this.options){
      if(this.options.autoplay) this.autoplay();
      if(this.options.navigation) this.bindButtons();
    }
  }

  handleMediaQuery(mql) {
    if (mql.matches) {
      this.bindListeners();
      this.phone = false;
    } else {
      this.unbindListeners();
      this.phone = true;
    }
  }

  autoplay() {
    clearInterval(this.autoplayInterval);

    if(!this.phone){
      setTimeout(() => {
        this.swiper.slideTo(1);
        const translationValue = -1 * this.swiperWrapperW;
        this.swiper.setTranslate(translationValue);
      }, this.options.autoplaySpeed * 1010);
    }else{
      setTimeout(() => {
        this.swiper.slideTo(1);
      }, this.options.autoplaySpeed * 1010);
    }

    this.autoplayInterval = setInterval(() => {
      this.slideNext();
    }, this.options.autoplaySpeed * 1000);
  }

  slideNext() {
    if (this.phone){
      if(this.allSlides.length - this.swiper.activeIndex == 0) this.swiper.slideTo(0);
      else this.swiper.slideNext();
    } else {
      if(this.allSlides.length - this.swiper.activeIndex == 3) this.swiper.slideTo(0);
      else this.swiper.slideNext();
    }
  }

  slidePrev() {
      if(this.swiper.activeIndex == 0) this.swiper.slideTo(this.allSlides.length);
      else this.swiper.slideTo(this.swiper.activeIndex - 1);
  }

  onSwiperResize() {
    this.swiperWrapperW = this.swiper.wrapperEl.clientWidth * 0.26635;
    this.slideChangeR();
  }

  bindObserver() {
    const toReveal = this.element.querySelector(".revealImageSlideshow");
    const toRevealImage = this.element.querySelector(".ImageSlideshow--ImageWrapper .swiper");

    if (!toReveal || !toRevealImage) return;
    this.checkEverySecond();

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
          var delay;
          if(this.seconds > 1) delay = 100;
          else delay = 350
          setTimeout(() => {
            if (entry.isIntersecting || entry.intersectionRatio == 1) {
            clearInterval(this.observerInterval);
            toReveal.classList.add("show");
            toRevealImage.classList.add("revealImage");
            observer.unobserve(entry.target);
            }
          }, delay);
      });
    });

    observer.observe(toReveal);
  }

  bindButtons() {
    const prevButtons = this.element.querySelectorAll('.swiper-button-prev');
    const nextButtons = this.element.querySelectorAll('.swiper-button-next');

    nextButtons.forEach(button => button.addEventListener('click', this.slideNext.bind(this)));
    prevButtons.forEach(button => button.addEventListener('click', this.slidePrev.bind(this)));
  }

  bindListeners() {
    this.swiper.on("slideNextTransitionStart", this.swiperListeners.get("slideNextTransitionStart"));
    this.swiper.on("slidePrevTransitionStart", this.swiperListeners.get("slidePrevTransitionStart"));
    this.swiper.on("slideResetTransitionStart", this.swiperListeners.get("slideResetTransitionStart"));
    window.addEventListener("resize", this.swiperListeners.get("resize"));

    setTimeout(() => {
      this.onSwiperResize();
    }, 800);
  }

  unbindListeners() {
    this.swiper.off("slideNextTransitionStart", this.swiperListeners.get("slideNextTransitionStart"));
    this.swiper.off("slidePrevTransitionStart", this.swiperListeners.get("slidePrevTransitionStart"));
    this.swiper.off("slideResetTransitionStart", this.swiperListeners.get("slideResetTransitionStart"));
    window.removeEventListener("resize", this.swiperListeners.get("resize"));

    setTimeout(() => {
      this.swiper.slideTo(this.swiper.activeIndex);
    }, 100);
  }

  debounce(func, delay) {
    let timeoutId;

    return function (...args) {
      clearTimeout(timeoutId);

      timeoutId = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }

  slideReset() {
    if (this.shouldIgnore) {
      return;
    }
    const translationValue = -this.swiper.activeIndex * this.swiperWrapperW;
    this.swiper.setTranslate(translationValue);
  }

  slideChangeR(){
    if (this.shouldIgnore) {
      return;
    }

    this.shouldIgnore = true;
    setTimeout(() => {
      this.shouldIgnore = false;
    }, 50);

    const translationValue = -this.swiper.activeIndex * this.swiperWrapperW;
    this.swiper.slideTo(this.swiper.activeIndex);
    this.swiper.setTranslate(translationValue);
  }

  slideChangeL(){
    if (this.shouldIgnore) {
      return;
    }

    this.shouldIgnore = true;
    setTimeout(() => {
      this.shouldIgnore = false;
    }, 50);

    const translationValue = -this.swiper.activeIndex * this.swiperWrapperW;
    this.swiper.slideTo(this.swiper.activeIndex);
    this.swiper.setTranslate(translationValue);
  }
}
customElements.define("image-slideshow", ImageSlideshow);

class CommentSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.whireCommentBtn = this.element.querySelector('.Comments--WhireButton');
    this.revealWrapper = this.element.querySelector('.Comments--RevealWrapper');
    this.currentPageKey = this.extractStringFromURL(window.location.href);
    this.options = JSON.parse(this.getAttribute("data-settings"));
    this.articleWrapper = this.element.querySelector('.Comments--ArticleWrapper');
    if(this.articleWrapper) this.allChildren = Array.from(this.articleWrapper.children);
    this.paginationWrapper = this.element.querySelector('.Pagination-Wrapper');
   /*  this.loadMoreBtn = this.element.querySelector('.Comments--loadMoreButton'); */

    const beenHere = sessionStorage.getItem('postRequest');
    if (beenHere == this.currentPageKey) {
      this.revealWrapper.style.height = "fit-content";
      this.whireCommentBtn.style.display = "none";
    } else {
      this.bindWhireBtnListener();
    }

    if (window.innerWidth < 1024) this.mobile = true;
    else this.mobile = false;

    const openedComments = sessionStorage.getItem('openedComments');
    //if (!openedComments) this.reduceArticles();
    //else this.loadMoreBtn.style.display = "none";
      this.handleAfterState();
    this.bindListeners();
  }

  bindListeners() {
    this.delegateElement.on('click', '[data-action="load-more"]', this.loadMore.bind(this));
    this.textArea = this.element.querySelector('#CommentForm-body');
    const formListener = this.element.querySelector('#comment_form');


    this.textAreaFunc =  this.expandDynamically.bind(this);
/*     if(this.loadMoreBtn) this.loadMoreBtn.addEventListener('click', this.updateComments.bind(this)); */
    formListener.addEventListener('submit', this.verifyForm.bind(this));
    window.addEventListener("resize", this.onResize.bind(this));
  }

handleAfterState(){
  if (window.location.href.indexOf("#comment_form") > -1) {
    this.element.querySelector('.Comments--WhireButton').setAttribute('aria-hidden', 'true');
  }
}

loadMore(event, target){

  const _this = this;
  let dataHref = target.getAttribute("data-href");


  return fetch(window.routes.localeRootUrl + dataHref, {
    credentials: "same-origin",
    method: "GET",
  }).then(function (content) {
    content.text().then(function (htmlData) {
      let html = new DOMParser().parseFromString(htmlData, "text/html");
      let newComments = html.querySelectorAll('.ArticleComments--Comment');

   let curDocument = _this.element.querySelector('.ArticleComments');
    curDocument.append(...newComments);
      let dataHref = html.querySelector('.comments--buttonFooter');

      if(dataHref){
        dataHref = dataHref.dataset.href;
      _this.element.querySelector('.comments--buttonFooter').dataset.href = dataHref;
      }else{
        _this.element.querySelector('.comments--buttonFooter').remove();

      }
    });
  });

}
  reduceArticles(){
    if(this.paginationWrapper) this.paginationWrapper.style.display = "none";

    if(this.articleWrapper){
      while (this.articleWrapper.children.length > 3) {
        this.articleWrapper.removeChild(this.articleWrapper.lastChild);
      }
    }
  }

  updateComments() {
    this.loadMoreBtn.style.display = "none";

    for (const child of this.allChildren) {
      this.articleWrapper.appendChild(child);
    }

    this.paginationWrapper.style.display = "block";
    sessionStorage.setItem("openedComments", true);
  }

  verifyForm(e) {
    const requiredCheckboxes = document.querySelectorAll('.Comments--Required input');
  const uncheckedCheckboxes = [];

  requiredCheckboxes.forEach((checkbox) => {
    if (!checkbox.checked) uncheckedCheckboxes.push(checkbox);
  });

  if (uncheckedCheckboxes.length > 0) {
    e.preventDefault();

    uncheckedCheckboxes.forEach((checkbox) => {
      const errorMessageElement = checkbox.closest('.Comments--Checkbox').querySelector('.Comments--ErrorMessage');
      if (errorMessageElement) errorMessageElement.classList.add('showCommentErrorMsg');
    });
  } else {
    if (this.currentPageKey.includes("#comment_form")) {
      sessionStorage.setItem("postRequest", this.currentPageKey);
    } else {
      sessionStorage.setItem("postRequest", this.currentPageKey + "#comment_form");
    }
  }
}

  onResize() {
    if (window.innerWidth < 1024) {
      this.textArea.addEventListener("input", this.textAreaFunc);
      this.expandDynamically();
      this.mobile = true;
    } else {
      this.textArea.removeEventListener("input", this.textAreaFunc);
      this.textArea.style.height = '128px';
      this.mobile = false;
    }
  }

  expandDynamically() {
    this.textArea.style.height = '42px';

    const scrollHeight = Math.max(this.textArea.scrollHeight, this.textArea.clientHeight);
    if (scrollHeight < 42) return;
    this.textArea.style.height = scrollHeight + 'px';
  }

  extractStringFromURL(url) {
    const parts = url.split('/'); 
    return parts[parts.length - 1];
  }

  calculateFitContentHeight(elem) {
    const clone = elem.cloneNode(true);
    clone.style.visibility = 'hidden';
    clone.style.height = 'fit-content';
    this.element.appendChild(clone);
    const computedHeight = window.getComputedStyle(clone).height;
    this.element.removeChild(clone);

    return computedHeight;
  }

  bindWhireBtnListener() {
    this.wooshListener = this.woosh.bind(this);
    this.whireCommentBtn.addEventListener("click", this.wooshListener);
  }

  woosh(e){
    e.preventDefault();
    this.whireCommentBtn.style.opacity = "0";
    this.whireCommentBtn.style.pointerEvents = "none";
    if(this.mobile) this.whireCommentBtn.style.marginTop = "-68px";

    const height = this.calculateFitContentHeight(this.revealWrapper);
    this.revealWrapper.style.height = height;
    setTimeout(() => {
      this.revealWrapper.style.height = "fit-content";
      this.whireCommentBtn.style.display = "none";
    }, 1000)

    this.whireCommentBtn.removeEventListener("click", this.wooshListener);
  }
}
customElements.define("comment-section", CommentSection);


class Search extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    // Find result elements
    this.resultElements = this.element.querySelectorAll(".Search--Result");

    // Find buttons to toggle between products and articles
    this.openProductBtn = this.element.querySelector("#productBtn");
    this.openArticleBtn = this.element.querySelector("#articleBtn");
    new AddToCart(this.element);
    this.bindEvents();

    // Find number of products and articles and display them
    const productElements = this.element.querySelectorAll(".SearchProductWrapper");
    const productNumber = productElements.length;
    const itemNumber = this.element.querySelector(".itemNumber");
    if (itemNumber) {
      itemNumber.innerHTML = productNumber;
      if (productNumber === 0) {
        this.openProductBtn.style.display = "none";
      }
    }

    const articleElements = this.element.querySelectorAll(".article-wrapper");
    const articleNumber = articleElements.length;
    const itemNumber_2 = this.element.querySelector(".itemNumber_2");
    if (itemNumber_2) {
      itemNumber_2.innerHTML = articleNumber;
      if (articleNumber === 0) {
        this.openArticleBtn.style.display = "none";
      }
    }

    this.showProducts();
  }

  bindEvents() {
    // Toggle between products and articles when buttons are clicked
    this.delegateElement.on(
      "click",
      '[data-action="toggle-products"]',
      this.showProducts.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="toggle-articles"]',
      this.showArticles.bind(this)
    );
  }

  showProducts() {
    // Show product elements and hide article elements
    const productElements = this.element.querySelectorAll(".SearchProductWrapper");
    if (!productElements.length) {
      return;
    }
    const articleElements = this.element.querySelectorAll(".article-wrapper");
    articleElements.forEach((article) => {
      article.classList.add("hidden");
    });
    productElements.forEach((product) => {
      product.classList.remove("hidden");
    });

    // Update button styles
    this.openProductBtn.classList.add("active");
    this.openArticleBtn.classList.remove("active");

    this.openProductBtn.classList.add("underline");
    this.openArticleBtn.classList.remove("underline");
  }

  showArticles() {

    // Show article elements and hide product elements
    const articleElements = this.element.querySelectorAll(".article-wrapper");
    if (!articleElements.length) {
      return;
    }
    const productElements = this.element.querySelectorAll(".SearchProductWrapper");
    productElements.forEach((product) => {
      product.classList.add("hidden");
    });
    articleElements.forEach((article) => {
      article.classList.remove("hidden");
    });

    // Update button styles
    this.openProductBtn.classList.remove("active");
    this.openArticleBtn.classList.add("active");

    this.openProductBtn.classList.remove("underline");
    this.openArticleBtn.classList.add("underline");
  }
}

customElements.define("search-component", Search);

class MainMenuDropdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.SidebarMenu = new Drawer(this.element);

    this.carouselElement = this.element.querySelector(".MenuSlideshowMobile");
    if( this.element.querySelector('.mobileMenu--collectionMenuWrapper') !== null){
    this.setActiveCollections();
    }
    this.bindEvents();


   

    
  }

  

  setActiveCollections(){
  
      const activeTab = this.element.querySelector(".tab-button--mobile.active");
      const activeTabAtribute = activeTab.getAttribute('data-tab');
      const collectionList = this.element.querySelectorAll(".mobileMenu--collectionItemWrapper");
      collectionList.forEach(item => {
        let atribute = item.getAttribute('data-tab');
      
        if(activeTabAtribute === atribute ){
          item.style.display = 'block';
        }else{
          item.style.display = 'none';
        }
      })
  
   
  }

  toggleTabCollection(event){
    const tabs = this.element.querySelectorAll('.tab-button--mobile');
    tabs.forEach(tab => {
      tab.classList.remove('active');
      tab.classList.remove('underline');
    });

    event.target.classList.add('active');
    event.target.classList.add('underline');

    
    this.setActiveCollections();
  }

  bindEvents() {
    document.addEventListener("sidebar-drawer:open", this.onDrawerListener);
    this.delegateElement.on(
      "click",
      '[data-action="toggle-subdrawer"]',
      this.toggleNextElement.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="toggle-prev-subdrawer"]',
      this.togglePreviusElement.bind(this)
    );

    this.delegateElement.on('click', 
    '[data-action="toggle-tab-collection"]',
     this.toggleTabCollection.bind(this)
     );
  }



  toggleNextElement(event, target){
    var nextEl = target.getAttribute('data-toggle-id'),
      subdrawer = this.element.querySelector('#'+nextEl);

      if(subdrawer && subdrawer.getAttribute('aria-hidden') == "true" ){
          subdrawer.setAttribute('aria-hidden', "false");

      }

  }
  togglePreviusElement(event, target){

    target.closest('.SidebarDrawer--Wrapper').setAttribute("aria-hidden", "true");

  }
}
customElements.define("main-menu-dropdown", MainMenuDropdown);

if(!window.theme.enableAnimations){
  const revealElements = document.querySelectorAll('.revealFeaturedImages');
  revealElements.forEach(elem => elem.classList.remove('revealFeaturedImages'));
}